export const construyeTuCaminoData = [
    {
        "curp": "JAEC791210HDFRSR08",
        "camino": "SAN JUAN HUEYAPAN-AGUACATITLA",
        "municipio": "HUASCA DE OCAMPO",
        "localidad": "SAN JUAN HUEYAPAN",
        "solicitante": "CARLOS ALBERTO JARILLO ESQUIVEL",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HELG950118MMCRRB09",
        "camino": "SINGUILUCAN-PALMILLAS",
        "municipio": "TEPEAPULCO",
        "localidad": "TLACATEPA",
        "solicitante": "GABRIELA HERNÁNDEZ LIRA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CUHP970317HHGRRT09",
        "camino": "PALO VERDE-EL DEXTHO",
        "municipio": "HUEHUETLA",
        "localidad": "PALO VERDE",
        "solicitante": "PATRICIO CRUZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PEGG970903HHGRRR08",
        "camino": "INTERMUNICIPAL NOGAL IXMIQUILPAN-PALACIOS CARDONAL",
        "municipio": "CARDONAL",
        "localidad": "SAN CLEMENTE",
        "solicitante": "GREGORIO PÉREZ GARCÍA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEVE730818MHGRTL03",
        "camino": "BARRIO DEL SALTO-NÚÑEZ SOTO",
        "municipio": "HUAUTLA",
        "localidad": "BARRIO DEL SALTO",
        "solicitante": "ELENA HERNÁNDEZ VITE",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BANA720620HHGTTD04",
        "camino": "OLOTLA-TLAMAMALA",
        "municipio": "TLANCHINOL",
        "localidad": "OLOTLA",
        "solicitante": "ADOLFO BAUTISTA NATIVIDAD",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AOLL810315HHGCPS09",
        "camino": "MAGDALENA-EL RINCÓN",
        "municipio": "ACTOPAN",
        "localidad": "MAGDALENA",
        "solicitante": "JOSÉ LUIS ACOSTA LÓPEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SEER010314HHGRSDA8",
        "camino": "PROLONGACIÓN DE LA CALLE AGUSTÍN MELGAR",
        "municipio": "SAN AGUSTÍN TLAXIACA",
        "localidad": "SAN JUAN TILCUAUTLA",
        "solicitante": "RODRIGO SERRANO ESTRADA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "ZAHJ930430HMCMRR08",
        "camino": "CAMINO S/N COMUNIDAD PAPAXTLA",
        "municipio": "ZACUALTIPÁN DE ÁNGELES",
        "localidad": "PAPAXTLA",
        "solicitante": "JORGE MANUEL ZAMORA HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SAMJ800412HHGNRL06",
        "camino": "LOS COYOTES-LAS FLORES",
        "municipio": "SAN FELIPE ORIZATLÁN",
        "localidad": "LOS COYOTES",
        "solicitante": "JULIO SÁNCHEZ MARTÍNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "FEME781220MDFRRL02",
        "camino": "SAN JERÓNIMO-SANTA ROSA",
        "municipio": "EL ARENAL",
        "localidad": "SAN JERÓNIMO",
        "solicitante": "ELVIA SANDRA FERNÁNDEZ MARTÍNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "YENG911017HHGRPL02",
        "camino": "EL NOGAL",
        "municipio": "IXMIQUILPAN",
        "localidad": "EL MANANTIAL",
        "solicitante": "GILBERTO YERBAFRIA NOPAL",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PEMC940215HHGRRR00",
        "camino": "ZOQUITAL-SAN NICOLÁS EL XATHE-EL RINCÓN DEL XATHE-EL ORNILLO-AMAJAC",
        "municipio": "ATOTONILCO EL GRANDE",
        "localidad": "EL ZOQUITAL",
        "solicitante": "CARLOS MIGUEL PÉREZ MORENO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEGL861017HHGRBR01",
        "camino": "ACAHUASCO-CHICHATLA",
        "municipio": "TLANCHINOL",
        "localidad": "ACAHUASCO",
        "solicitante": "LORENZO HERNÁNDEZ GABRIEL",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEFN950209HHGRNL0",
        "camino": "ACCESO A LA COMUNIDAD DE LAS PALMITAS",
        "municipio": "LA MISIÓN",
        "localidad": "PALMITAS",
        "solicitante": "NOEL HERNÁNDEZ FUENTE",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BAIA931017MHGRSR03",
        "camino": "LOS PINOS-LOS SABINOS",
        "municipio": "ATOTONILCO EL GRANDE",
        "localidad": "LOS SABINOS",
        "solicitante": "ARIANA EVELYN BARDALES ISLAS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BERC690925MHGNZL08",
        "camino": "DE LA IGLESIA AL PANTEÓN Y DEL PANTEÓN A LA PRIMARIA",
        "municipio": "METEPEC",
        "localidad": "CAÑADA DE FLORES",
        "solicitante": "CLEOFÁS BENÍTEZ RUIZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SAGL760616HHGNRB18",
        "camino": "AVENIDA DEL AUTÓDROMO, FRANCISCO VILLA",
        "municipio": "EPAZOYUCAN",
        "localidad": "FRANCISCO VILLA",
        "solicitante": "LEOBALDO SANTANDER GARCÍA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MARU820608HHGYQR07",
        "camino": "EL BINGÜ-EL ESPÍRITU",
        "municipio": "CARDONAL",
        "localidad": "EL BINGÜ",
        "solicitante": "URIEL MAYE ROQUE",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "EALE890412HHGSGD02",
        "camino": "ACCESO NAXTHEY-TAXHIE",
        "municipio": "ALFAJAYUCAN",
        "localidad": "NAXTHEY",
        "solicitante": "EDUARDO ESCAMILLA LUGO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RESJ740519HHGNS08",
        "camino": "LA TIENDA-LA PLACITA",
        "municipio": "TECOZAUTLA",
        "localidad": "SAN ANTONIO",
        "solicitante": "JESÚS RESÉNDIZ SAN NICOLÁS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GULI880824HHGZCZ02",
        "camino": "ACCESO A LA LOCALIDAD DE SANTIAGO",
        "municipio": "LOLOTLA",
        "localidad": "SANTIAGO",
        "solicitante": "IZRAEL GUZMÁN LECHUGA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AIBG000406HHGVDVA1",
        "camino": "CHACAYA-ALMOLON",
        "municipio": "ELOXOCHITLÁN",
        "localidad": "CHACAYÁ",
        "solicitante": "GIOVANI AVILÉS BADILLO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "VAVJ761014HHGZRN01",
        "camino": "LA CORONILLA-ENTRONQUE ALMOLOYA-TEPOZÁN",
        "municipio": "ALMOLOYA",
        "localidad": "LA CORONILLA",
        "solicitante": "JUAN MANUEL VÁZQUEZ VARGAS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "ZATR580310HHGYLD09",
        "camino": "TEPEPOTLUXCO-AVILES",
        "municipio": "ALMOLOYA",
        "localidad": "TEPEPOTLUXCO",
        "solicitante": "RODRIGO ZAYAGO TÉLLEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MOQT761029MMCNND00",
        "camino": "LA ORDEÑA-RANCHO NUEVO",
        "municipio": "ALMOLOYA",
        "localidad": "LA ORDEÑA",
        "solicitante": "MARÍA TEODORA MONTALVO QUINTOS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RERL851009HGBMN02",
        "camino": "LA MESA-LA GLORIA",
        "municipio": "CARDONAL",
        "localidad": "LA MESA",
        "solicitante": "LEONEL REBOLLEDO RAMÍREZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AAAA790817HHGTTP05",
        "camino": "SANTIAGO TEPEPA-EL TIGRE-COYAMETEPEC",
        "municipio": "ACAXOCHITLÁN",
        "localidad": "SANTIAGO TEPEPA",
        "solicitante": "APOLINAR ATLAGCO ATICPAC",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "DUGL700510HHGRRS05",
        "camino": "AGUACATITLA",
        "municipio": "HUASCA DE OCAMPO",
        "localidad": "AGUACATITLA",
        "solicitante": "JOSÉ LUIS DURAN GARCÍA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "TEMM931226HHGRRR00",
        "camino": "COL. LOS NERIAS-EL POZO",
        "municipio": "CARDONAL",
        "localidad": "DURANGO DABOXTHA",
        "solicitante": "MAURILIO TREJO MORGADO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "VEED681113HHGLSG99",
        "camino": "LA CAÑADA-EL HUARICHE",
        "municipio": "HUASCA DE OCAMPO",
        "localidad": "LA CAÑADA",
        "solicitante": "DIEGO VELÁZQUEZ ESCORZA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BAAL730418MHGRGZ01",
        "camino": "AMPLIACIÓN BARTOLOMÉ",
        "municipio": "HUASCA DE OCAMPO",
        "localidad": "SAN BARTOLOMÉ",
        "solicitante": "LUZ MARÍA BRACHO AGUILAR",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEMM880326HHGRXG06",
        "camino": "CAMINO VIEJO TEXCATZONGO-TEMOMUZGO",
        "municipio": "TEPEAPULCO",
        "localidad": "TEXCATZONGO",
        "solicitante": "MIGUEL ÁNGEL HERNÁNDEZ MUÑOZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "VAML850816MHGRNR01",
        "camino": "TORTUGAS-ACUCUL CEBOLLETAS",
        "municipio": "METEPEC",
        "localidad": "ACUCUL CEBOLLETAS",
        "solicitante": "LORENA VARGAS MONTIEL",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MORG570309HHGNYR06",
        "camino": "AV. HIDALGO-CAMINO REAL",
        "municipio": "MINERAL DE LA REFORMA",
        "localidad": "LA PILA",
        "solicitante": "GREGORIO MONTIEL REYES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "TIHC880202HHGRRN04",
        "camino": "ZAPOTE ARRIBA-SANTA ROSA TETLAMA",
        "municipio": "SAN FELIPE ORIZATLÁN",
        "localidad": "ZAPOTE ARRIBA",
        "solicitante": "CÁNDIDO GABINO TRINIDAD HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "ROGN731029HHGSNR08",
        "camino": "CAMINO PRINCIPAL-COBAEH",
        "municipio": "TEPEHUACÁN DE GUERRERO",
        "localidad": "CUATOLOL",
        "solicitante": "NARCISO ROSALES GONZÁLEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "VIJJ781204MHGLNN00",
        "camino": "ACCESO A EL NEDHAY",
        "municipio": "NICOLÁS FLORES",
        "localidad": "CERRO PRIETO",
        "solicitante": "JUANA VILLEDA JUANICO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEAE860408MHGRNV01",
        "camino": "CAMINO VIEJO",
        "municipio": "SAN SALVADOR",
        "localidad": "SAN ANTONIO ABAD",
        "solicitante": "EVA HERNÁNDEZ ÁNGELES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CAZV880916HHGBMC09",
        "camino": "MORELOS-EL MANZANO",
        "municipio": "OMITLÁN DE JUÁREZ",
        "localidad": "EL MANZANO",
        "solicitante": "VÍCTOR HUGO CABRERA ZAMORA ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "VAMM000224MHGRNRA7",
        "camino": "ACCESO PRINCIPAL CUMBRE JAGUEY SECO",
        "municipio": "METZTITLÁN",
        "localidad": "LA CUMBRE JAGUEY SECO",
        "solicitante": "MORELIA VARGAS MONROY",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MARV771023MHGRMR05",
        "camino": "ACCESO A SAN FELIPE",
        "municipio": "ZIMAPÁN",
        "localidad": "SAN FELIPE",
        "solicitante": "VERÓNICA MARTÍNEZ RAMÍREZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MODJ800514HHGRSV00",
        "camino": "ACCESO AL ÁLAMO",
        "municipio": "PISAFLORES",
        "localidad": "EL ÁLAMO",
        "solicitante": "JAVIER MORALES DÍAS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEHG730728HHGRRB02",
        "camino": "ECUATITLA-HUIZOTLACO",
        "municipio": "HUEHUETLA",
        "localidad": "ECUATITLA",
        "solicitante": "GABRIEL HERNÁNDEZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GAMJ721022HHGRJN05",
        "camino": "ACCESO A PALO GORDO",
        "municipio": "METEPEC",
        "localidad": "PALO GORDO",
        "solicitante": "JUAN GRANILLO MEJÍA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BEFF031022HHGNLRA6",
        "camino": "COYAMETEPEC-ACAXOCHITLÁN",
        "municipio": "ACAXOCHITLÁN",
        "localidad": "COYAMETEPEC",
        "solicitante": "FERNANDO BENIGNO FLORENCIO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CAFA930907HHGRLD11",
        "camino": "TLAMAYA-ACOYATLA",
        "municipio": "TIANGUISTENGO",
        "localidad": "ATECOXCO",
        "solicitante": "RICARDO ACUAYTE CORTES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "TELG991015HHGRPD02",
        "camino": "EL DEPOSITO DE AGUA",
        "municipio": "LA MISIÓN",
        "localidad": "LA CIÉNEGA",
        "solicitante": "JOSÉ GUADALUPE TREJO LÓPEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RAHM951223MHGMRR05",
        "camino": "CONTINUIDAD SAN ISIDRO-SANTA ANA-SAN JUAN APÓSTOL",
        "municipio": "ZACUALTIPÁN DE ÁNGELES",
        "localidad": "ZACUALTIPÁN",
        "solicitante": "MARISOL RAMÍREZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CUMM870817HDFRNL09",
        "camino": "CAMINO REAL",
        "municipio": "HUEHUETLA",
        "localidad": "SAN GUILLERMO",
        "solicitante": "JOSÉ MILTON DE LA CRUZ MANILLA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GUGM830130MHGRNR00",
        "camino": "VÍA AL SALTO (EL TÚNEL)",
        "municipio": "TEPEJI DEL RIO",
        "localidad": "TIANGUISTENGO LA ROMERA",
        "solicitante": "MARTINA GUERRERO GONZÁLEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "YABA891215MHGXRN04",
        "camino": "ACCESO A LAS ADJUNTAS",
        "municipio": "ZIMAPÁN",
        "localidad": "LAS ADJUNTAS",
        "solicitante": "MARÍA ANALINE YÁÑEZ BÁRCENAS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GAMF611004HHGYNR08",
        "camino": "LINDA VISTA II",
        "municipio": "HUEHUETLA",
        "localidad": "LINDA VISTA II",
        "solicitante": "FRANCISCO GAYOSSO MENDOZA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MATE811023HHGRJR09",
        "camino": "LOS PINOS",
        "municipio": "ACTOPAN",
        "localidad": "CAÑADA CHICA ANTIGUA",
        "solicitante": "ERIK MARTÍNEZ TEJEDA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AUID690925HHGGSG00",
        "camino": "PILCHIATIPA-HUILOTITLA I",
        "municipio": "HUAZALINGO",
        "localidad": "PILCHIATIPA",
        "solicitante": "DIEGO AGUSTÍN ISABEL",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SIPG820227HHGMXB03",
        "camino": "NEQUETEJE-VAZQUEZ REMEDIOS",
        "municipio": "IXMIQUILPAN",
        "localidad": "NEQUETEJE",
        "solicitante": "GABRIEL SIMÓN PEÑA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "REFL940707HHGYRR03",
        "camino": "PUERTECITO DE MEGÜI-MEGÜI",
        "municipio": "ZIMAPÁN",
        "localidad": "MEGÜI",
        "solicitante": "LORENZO REYNOSO FERRERA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "COCR930313HHGRRH01",
        "camino": "EL MANDHO-EL DEXTHO",
        "municipio": "IXMIQUILPAN",
        "localidad": "EL MANDHO",
        "solicitante": "RIGOBERTO CORONA CORONA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GOVR800917HHGNLB08",
        "camino": "ACCESO A EL MOLINO",
        "municipio": "CARDONAL",
        "localidad": "RANCHERÍA EL MOLINO",
        "solicitante": "ROBERTO GONZÁLEZ VALENCIA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "JIGA770604HHGMRB09",
        "camino": "EL CONVENTO-LA LAGUNA",
        "municipio": "ATOTONILCO EL GRANDE",
        "localidad": "TILTEPEC",
        "solicitante": "ABELINO JIMÉNEZ GARCÍA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "COGA841218HHGRMS07",
        "camino": "EL AGUACATE",
        "municipio": "NICOLÁS FLORES",
        "localidad": "EL AGUACATE",
        "solicitante": "AUSENCIO CORONA GÓMEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MAPY741217MHGRTL02",
        "camino": "ENTRONQUE EL ÁLAMO-CERRO DE GUADALUPE",
        "municipio": "PISAFLORES",
        "localidad": "CERRO DE GUADALUPE",
        "solicitante": "YOLANDA MARTÍNEZ PATRICIO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GUCM810618HHGRVC05",
        "camino": "LA ARENA-CHALAHUITITO",
        "municipio": "PISAFLORES",
        "localidad": "LA ARENA",
        "solicitante": "MACEDONIO GUERRERO COVARRUBIAS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "EAJT590819HHGSMM08",
        "camino": "ACCESO A CAXPOJAY",
        "municipio": "SAN SALVADOR",
        "localidad": "DEXTHO DE VICTORIA",
        "solicitante": "TIMOTEO ESCAMILLA JIMÉNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "OAPE870411HHGCRS08",
        "camino": "CERRO BLANCO-OLIVO",
        "municipio": "IXMIQUILPAN",
        "localidad": "CERRO BLANCO",
        "solicitante": "ESTANISLAO OCAÑA PÉREZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PERO830322HHGPMC04",
        "camino": "CUESTA COLORADA-TEXCADHO",
        "municipio": "IXMIQUILPAN",
        "localidad": "CUESTA COLORADA",
        "solicitante": "OCTAVIANO PEPE ROMERO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GIME971113MHGLRL06",
        "camino": "ACCESO A SAN MARCOS",
        "municipio": "TLAHUILTEPA",
        "localidad": "SAN MARCOS",
        "solicitante": "ELISA GIL MARTÍNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RUAH980220HHGBNR00",
        "camino": "CALLE ´PRINCIPAL",
        "municipio": "TLAHUILTEPA",
        "localidad": "EL DURAZNITO",
        "solicitante": "HERIBERTO RUBIO ANDRADE",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "ZEOB891117MHGNTL05",
        "camino": "ACCESO PRINCIPAL COYOCALA",
        "municipio": "TLAHUILTEPA",
        "localidad": "COYOCALA",
        "solicitante": "BLANCA ESTELA ZENIL OTERO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AUTA660927HHGGRD07",
        "camino": "ACCESO PRINCIPAL SAN ANTONIO-XOCHITLÁN",
        "municipio": "MOLANGO",
        "localidad": "SAN ANTONIO",
        "solicitante": "ADOLFO AGUSTÍN TRINIDAD",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RAHA640206HHGMRL06",
        "camino": "CAMPO SANTO-POCANTLA",
        "municipio": "XOCHIATIPAN",
        "localidad": "POCANTLA",
        "solicitante": "ALONSO RAMÍREZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BELF871216HHGNPR08",
        "camino": "BANCO-YERBABUENA",
        "municipio": "SAN AGUSTÍN METZQUITITLAN",
        "localidad": "YERBABUENA",
        "solicitante": "FRANCO BENÍTEZ LÓPEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MACG790324MHGRHR05",
        "camino": "GUADALUPE-3RA MNZ XAMAGE",
        "municipio": "ALFAJAYUCAN",
        "localidad": "BOXTHO",
        "solicitante": "GRICELDA MARTÍNEZ CHÁVEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PAHL871006HHGLRS01",
        "camino": "CALLE LA ESCONDIDA",
        "municipio": "MINERAL DEL CHICO",
        "localidad": "CARBONERAS",
        "solicitante": "LUIS MIGUEL PALAFOX HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GOPD950809HHGMRG05",
        "camino": "CAMINO A TELESECUNDARIA 710",
        "municipio": "SANTIAGO DE ANAYA",
        "localidad": "EL ENCINO",
        "solicitante": "DIEGO GÓMEZ PÉREZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PEGA880613HHGRRN07",
        "camino": "ACCESO PRINCIPAL ACOCUL",
        "municipio": "METEPEC",
        "localidad": "ACOCUL",
        "solicitante": "ANTONIO PÉREZ GRANILLO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RACR710216HHGMHM02",
        "camino": "ACCESO PRINCIPAL SAN MIGUEL ALMOLON",
        "municipio": "ELOXOCHITLÁN",
        "localidad": "SAN MIGUEL ALMOLON",
        "solicitante": "RAMIRO RAMOS CHÁVEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CEHF831104HHGRRR02",
        "camino": "XALTIPA-LA PIMIENTA",
        "municipio": "TLANCHINOL",
        "localidad": "XALTIPA",
        "solicitante": "FERMÍN CERECEDO HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AOLC971211HHGCRR02",
        "camino": "CALLE DINAMARCA",
        "municipio": "TASQUILLO",
        "localidad": "MOTHO",
        "solicitante": "CARLOS ACOSTA LORENZO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "LEGF490424MHGNRD03",
        "camino": "ACCESO A AMAQUE",
        "municipio": "MINERAL DE LA REFORMA",
        "localidad": "AMAQUE, PACHUQUILLA",
        "solicitante": "FIDELIA LEÓN GUERRERO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "JIGA770604HHGMRB09",
        "camino": "EL CONVENTO-LA LAGUNA",
        "municipio": "ATOTONILCO EL GRANDE",
        "localidad": "TILTEPEC",
        "solicitante": "ABELINO JIMÉNEZ GARCÍA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MEPM641212HHGNRN05",
        "camino": "CENTRAL-EJIDO",
        "municipio": "CARDONAL",
        "localidad": "SAN ANDRÉS DABOXTHA",
        "solicitante": "MANUEL MENDOZA PÉREZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "OURJ950322HHGLBR04",
        "camino": "BELISARIO DOMÍNGUEZ, 20 DE JULIO, SANTO DOMINGO, IGNACIO ALLENDE, AV. MIGUEL HIDALGO",
        "municipio": "IXMIQUILPAN",
        "localidad": "EL BARRIDO",
        "solicitante": "JORGE ANTONIO OLGUIN RUBIO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AOJL920209HHGMSS07",
        "camino": "IXMIQUILPAN-CARDONAL-CIRCUITO QUIXPEDHE",
        "municipio": "CARDONAL",
        "localidad": "SAN ANTONIO SABANILLAS",
        "solicitante": "LUIS ALBERTO AMBROSIO JOSÉ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AOJL920209HHGMSS07",
        "camino": "BARRIO LOS AMBROSIOS-VÍA PACHUCA",
        "municipio": "CARDONAL",
        "localidad": "SAN ANTONIO SABANILLAS",
        "solicitante": "LUIS ALBERTO AMBROSIO JOSÉ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "ROCV720719HHGDRC03",
        "camino": "TEPATETIPA-TLATEPEXE",
        "municipio": "METZTITLÁN",
        "localidad": "TEPATETIPA",
        "solicitante": "VICENTE RODRÍGUEZ CRUZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "VAFG751113HHGZLR02",
        "camino": "SAN JUAN IXTILMACO A C. CÁRDENAS-OCOTEPEC",
        "municipio": "APAN",
        "localidad": "SAN JUAN IXTILMACO",
        "solicitante": "GREGORIO VÁZQUEZ FLORES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "COMH840113MHGRXL00",
        "camino": "ACCESO A LA COMUNIDAD SAN DIEGO TLALAYOTE",
        "municipio": "APAN",
        "localidad": "SAN DIEGO TLALAYOTE",
        "solicitante": "HILARIA CORTES MUÑOZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CALR650809HHGSPM04",
        "camino": "TLAXOCOYUCAN-BARRIO SAN JUAN",
        "municipio": "HUASCA DE OCAMPO",
        "localidad": "TLAXOCOYUCAN",
        "solicitante": "ROMÁN CASTRO LÓPEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CUVF700301MHGRLL02",
        "camino": "SAN FELIPE-MORELOS",
        "municipio": "MIXQUIAHUALA DE JUÁREZ",
        "localidad": "TEPEITIC",
        "solicitante": "FELIZA CRUZ VALDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEHG820227MHGRRB05",
        "camino": "ACCESO A SAN AGUSTÍN CEBOLLETAS-YONTHE CHICO",
        "municipio": "ALFAJAYUCAN",
        "localidad": "SAN AGUSTÍN TLALIXTICAPA",
        "solicitante": "GABRIELA HERNÁNDEZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RORO600528HHGDML00",
        "camino": "SAN PABLO EL GRANDEZ",
        "municipio": "TENANGO DE DORIA",
        "localidad": "SAN PABLO EL GRANDE",
        "solicitante": "OLIVERIO RODRÍGUEZ ROMERO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "JICF610411HHGMRL09",
        "camino": "CENTRO IXCUINQUITLAPILCO-EL CAMPANARIO",
        "municipio": "SAN AGUSTÍN TLAXIACA",
        "localidad": "SAN MATEO IXCUINQUITLAPILCO",
        "solicitante": "FELIPE JIMÉNEZ CERÓN",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CUMF780620HHGRRD00",
        "camino": "CIRCUITO ORIENTE",
        "municipio": "TASQUILLO",
        "localidad": "EL DURAZNO",
        "solicitante": "FIDEL CRUZ MARTÍNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SAJA821002HHGNRN09",
        "camino": "LA CRUZ-CALLE BIXFANI-AV. LA LOMA",
        "municipio": "CHILCUAUTLA",
        "localidad": "EL DADHO",
        "solicitante": "ANDRÉS SAN PEDRO JERÓNIMO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "LOMJ771222HHGZRV00",
        "camino": "SIN NOMBRE",
        "municipio": "HUASCA DE OCAMPO",
        "localidad": "BARRIO EL HUARICHE",
        "solicitante": "JAVIER LOZADA MORALES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BAII830326HHGDSS07",
        "camino": "EL APARTADERO-CAÑADA DE AGUA BENDITA-LA MESA DEL DURAZNO",
        "municipio": "SAN AGUSTÍN METZQUITITLAN",
        "localidad": "EL APARTADERO",
        "solicitante": "ISAAC BADILLO ISLAS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "TOVJ721202MHGRZN08",
        "camino": "ACCESO A LA PRESA DOS CARLOS",
        "municipio": "MINERAL DE LA REFORMA",
        "localidad": "DOS CARLOS",
        "solicitante": "JUANA TORRES VÁZQUEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RERR870607HHGBBB05",
        "camino": "AGUA HEDEONDA-PANTADHO",
        "municipio": "METZTITLÁN",
        "localidad": "AGUA HEDEONDA",
        "solicitante": "ROBERTO REBOLLEDO REBOLLEDO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GORB851127HHGDJN00",
        "camino": "MAJADILLAS-ZACATEPEC",
        "municipio": "METEPEC",
        "localidad": "MOJADILLAS",
        "solicitante": "BENJAMÍN GODÍNEZ ROJAS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GOVF611006HHGMGR08",
        "camino": "AV. TEPATEPEC-CALLE VICENTE GUERRERO",
        "municipio": "FRANCISCO I. MADERO",
        "localidad": "LA COMUNIDAD",
        "solicitante": "FRANCISCO GÓMEZ VIGUERAS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AIRP801008MHGVZL02",
        "camino": "PUENTE PALOMAS-CALLE GAVIOTAS-CALLE VENTILLA",
        "municipio": "ZEMPOALA",
        "localidad": "ACELOTLA DE OCAMPO",
        "solicitante": "PAULINA ÁVILA RUIZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GUTI751105MHGZRS04",
        "camino": "LA PALMA",
        "municipio": "TASQUILLO",
        "localidad": "TETZHU",
        "solicitante": "MARÍA ISABEL GUZMÁN TREJO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MOHR731230HHGRRG05",
        "camino": "SAN MIGUEL FERRERÍA-E.C. ZACUALTIPÁN-SAN BERNARDO",
        "municipio": "ZACUALTIPÁN DE ÁNGELES",
        "localidad": "SAN MIGUEL FERRERÍA",
        "solicitante": "ROGELIO MORALES HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "VARG700322HHGLML00",
        "camino": "LONTLA-TLAHUELOMPA",
        "municipio": "TLANCHINOL",
        "localidad": "LONTLA",
        "solicitante": "GUILLERMO VALDIVIA ROMERO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MAMM790421MDFGRR01",
        "camino": "LA PARCELA-CRUCERO",
        "municipio": "ZIMAPÁN",
        "localidad": "EL SALITRE",
        "solicitante": "MARIANEL MAGALLANES MARTÍNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BATR950909HHGLLG03",
        "camino": "UNIÓN DE MONTECILLOS-APIPINALCO-LA CRUZ",
        "municipio": "ATOTONILCO EL GRANDE",
        "localidad": "MONTECILLOS",
        "solicitante": "ROGELIO BALDERRAMA TÉLLEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HESE620708HHGRNG02",
        "camino": "CASA VIEJA",
        "municipio": "SAN BARTOLO TUTOTEPEC",
        "localidad": "CALINTLA",
        "solicitante": "EUGENIO HERNÁNDEZ SANTOS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GOMP871220HHGMNB02",
        "camino": "MILPA GRANDE-SAN JUAN TLATEPEXE",
        "municipio": "METZTITLÁN",
        "localidad": "HUISTICOLA",
        "solicitante": "PABLO GÓMEZ MENDOZA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MAGE720902HHGRRS07",
        "camino": "EL DEMHA-BARRIO LA CRUZ",
        "municipio": "TASQUILLO",
        "localidad": "EL DEMHA",
        "solicitante": "ESTEBAN MARTIN GARCÍA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "LOCJ880904HHGPRN07",
        "camino": "BARRIO ORIENTE",
        "municipio": "SAN AGUSTÍN METZQUITITLAN",
        "localidad": "YERBABUENA",
        "solicitante": "JOSÉ JUAN LÓPEZ CRUZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEHH830113HHGRRL04",
        "camino": "ACCESO PRINCIPAL CAÑADITAS",
        "municipio": "SAN AGUSTÍN METZQUITITLAN",
        "localidad": "CAÑADITAS",
        "solicitante": "HILARIO HERNÁNDEZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CUHA801115HHGRRR08",
        "camino": "EL NOPALILLO",
        "municipio": "SANTIAGO DE ANAYA",
        "localidad": "HERMOSILLO MONTE NOBLE",
        "solicitante": "ARCENIO CRUZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PEAC831015HHGRGM05",
        "camino": "SAN NICOLÁS ATEXCOCO",
        "municipio": "SAN AGUSTÍN METZQUITITLAN",
        "localidad": "SAN NICOLÁS ATECOXCO",
        "solicitante": "CAMILO PERCASTRE AGUSTÍN",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BAAA830802MHGRNN03",
        "camino": "EL BANCO-CHICHINAPA",
        "municipio": "SAN AGUSTÍN METZQUITITLAN",
        "localidad": "CHICHINAPA",
        "solicitante": "MARÍA DE LOS ÁNGELES BARRERA ÁNGELES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SALG500802HHGNPL03",
        "camino": "AGUA BENDITA-LA PEÑA",
        "municipio": "SAN AGUSTÍN METZQUITITLAN",
        "localidad": "VELADERO",
        "solicitante": "GILBERTO SÁNCHEZ LÓPEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GOST700307HHGNLM03",
        "camino": "MZA. TIERRA COLORADA-CALLE LA PELLA",
        "municipio": "TASQUILLO",
        "localidad": "QUITANDEJHE",
        "solicitante": "TOMAS GONZÁLEZ SALDAÑA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PIGL630107HHGXMC03",
        "camino": "MILPILLAS-DURAZNO",
        "municipio": "SAN AGUSTÍN METZQUITITLAN",
        "localidad": "MILPILLAS",
        "solicitante": "LUCIANO PIÑA GÓMEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "NOEY950624MHGCSN03",
        "camino": "CAMINO A LA ESCUELA",
        "municipio": "SAN AGUSTÍN METZQUITITLAN",
        "localidad": "TUZANAPA",
        "solicitante": "YOANA NOCHEBUENA ESCAMILLA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PECJ850826HHGLRN01",
        "camino": "LOMA LA PAREJA-LOS ÁLAMOS",
        "municipio": "SAN AGUSTÍN METZQUITITLAN",
        "localidad": "LOS ÁLAMOS",
        "solicitante": "JUAN PELCASTRE CARRILLO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RIGA601121HHGSZL05",
        "camino": "ACCESO A LA LOCALIDAD DE MORELOS",
        "municipio": "OMITLÁN DE JUÁREZ",
        "localidad": "MORELOS",
        "solicitante": "ALBERTO RÍOS GUZMÁN",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BEHR701221HHGLRB00",
        "camino": "CALLE MONTE REAL",
        "municipio": "TEZONTEPEC DE ALDAMA",
        "localidad": "COL. NUEVO PANUAYA",
        "solicitante": "RUBÉN BELTRÁN HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "FASL910522HHGRNS09",
        "camino": "ACCESO PRINCIPAL A LAS PILAS",
        "municipio": "NICOLÁS FLORES",
        "localidad": "LAS PILAS",
        "solicitante": "JOSÉ LUIS FRANCO SANTANA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEVF970126HHGRTD07",
        "camino": "ACCESO A TEPEHICA",
        "municipio": "HUEJUTLA DE REYES",
        "localidad": "TEPEHICA",
        "solicitante": "FIDENCIO HERNÁNDEZ VITE",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "ROMD950913MHGMJN01",
        "camino": "ACCESO PRINCIPAL CUAXITHI",
        "municipio": "NOPALA DE VILLAGRÁN",
        "localidad": "CUAXITHI",
        "solicitante": "DIANA LAURA ROMERO MEJÍA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "LOCC960915MHGRRR00",
        "camino": "CENTRO A ALMACENAMIENTO DE AGUA POTABLE",
        "municipio": "IXMIQUILPAN",
        "localidad": "EL BANXU",
        "solicitante": "CAROLINA LORA CRUZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MARL790108MHGRDT00",
        "camino": "SAPEDRO-TZIDEJHE",
        "municipio": "TECOZAUTLA",
        "localidad": "SAN PEDRO",
        "solicitante": "LETICIA MARTÍNEZ RODRÍGUEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MARJ740208HHGRBN03",
        "camino": "ACCESO PRINCIPAL LAS VEGAS",
        "municipio": "NOPALA DE VILLAGRÁN",
        "localidad": "LAS VEGAS",
        "solicitante": "JUAN ANTONIO MARTÍNEZ REBOLLAR",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MAEJ851203HHGRSV04",
        "camino": "ACCESO PRINCIPAL EL CERRO DEL CARMEN",
        "municipio": "PISAFLORES",
        "localidad": "EL CERRO DEL CARMEN",
        "solicitante": "JAVIER MARTÍNEZ ESPINOZA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MAHA780122HHGRRN09",
        "camino": "LA LAGUNA-CASTADHO",
        "municipio": "NICOLÁS FLORES",
        "localidad": "CASTADHO",
        "solicitante": "ANASTACIO MARTÍNEZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HERP900630HHGRMB04",
        "camino": "PARTE ALTA DE LOS HERNÁNDEZ",
        "municipio": "PISAFLORES",
        "localidad": "LA GARGANTILLA",
        "solicitante": "PABLO HERNÁNDEZ RAMÍREZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "EATP741128MHGSLT03",
        "camino": "TERRERO-CANOAS-CARRIZAL CHICO",
        "municipio": "SAN AGUSTÍN METZQUITITLAN",
        "localidad": "CARRIZAL CHICO",
        "solicitante": "PETRA JUANA ESPAÑA TÉLLEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CUBN870612HVZRLB06",
        "camino": "AV. CIENEGUILLAS",
        "municipio": "SAN AGUSTÍN METZQUITITLAN",
        "localidad": "ARROYO HONDO",
        "solicitante": "NAVOR CRUZ VALDERAS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "FECB630823HHGLHN04",
        "camino": "CALLE PRINCIPAL DE LA COMUNIDAD-SALIDA AL PANTEÓN",
        "municipio": "PISAFLORES",
        "localidad": "LA GARGANTILLA",
        "solicitante": "BENICIO FÉLIX CHÁVEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEHA710519HHGRRL01",
        "camino": "CALLE ROSALES Y CONTINUACIÓN ACCESO BALNEARIO GANDHO",
        "municipio": "TECOZAUTLA",
        "localidad": "GANDHO",
        "solicitante": "ALFREDO HERNÁNDEZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "LOYB690106HHGPBL08",
        "camino": "CAPILLA SAN MIGUEL-CABECERA MUNICIPAL",
        "municipio": "SAN AGUSTÍN METZQUITITLAN",
        "localidad": "SAN MIGUEL",
        "solicitante": "BALTASAR LÓPEZ YBARRA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SACA760810HMCNRN04",
        "camino": "CALLE 13 PONIENTE",
        "municipio": "SAN AGUSTÍN METZQUITITLAN",
        "localidad": "CARPINTEROS",
        "solicitante": "JOSÉ ANTONIO SANTANA CRUZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HERN820726HHGRJL04",
        "camino": "REGIÓN DE COMUNIDADES UNIDAS",
        "municipio": "ATOTONILCO EL GRANDE",
        "localidad": "PARQUE DE LOS SAUCES",
        "solicitante": "NELSON JESÚS HERNÁNDEZ ROJAS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AUFH910408HHGQLL00",
        "camino": "CHAPALTEPEC-ENTRONQUE TIANGUISTENGO-YATIPAN",
        "municipio": "TIANGUISTENGO",
        "localidad": "CHAPALTEPEC",
        "solicitante": "HELIER RICARDO AQUINO FLORES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AEHO810203HHGZRS01",
        "camino": "REAL",
        "municipio": "EL ARENAL",
        "localidad": "CHIMILPA",
        "solicitante": "OSCAR AZPEITIA HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PAZM630922HHGRXR05",
        "camino": "AV. LA MESA",
        "municipio": "EL ARENAL",
        "localidad": "EL RINCÓN",
        "solicitante": "MAURICIO PAREDES ZÚÑIGA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PAHR780130MHGRRY09",
        "camino": "FRAY FRANCISCO-CERRO ALTO",
        "municipio": "EL ARENAL",
        "localidad": "FRAY FRANCISCO",
        "solicitante": "REYNA PAREDES HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BAJJ680107HHGTMS05",
        "camino": "LA CRUZITA-SAN JOSÉ TEPENENE",
        "municipio": "EL ARENAL",
        "localidad": "SAN JERÓNIMO",
        "solicitante": "J. JESÚS BAUTISTA JIMÉNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PAHR780130MHGRRY09",
        "camino": "SAN ANDRÉS TIANGUISTENGO-FRAY FRANCISCO",
        "municipio": "EL ARENAL",
        "localidad": "FRAY FRANCISCO",
        "solicitante": "REYNA PAREDES HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "VAMF810509HHGRLR07",
        "camino": "SAN JUAN CUAHUTENGO",
        "municipio": "SAN AGUSTÍN METZQUITITLAN",
        "localidad": "SAN JUAN CUAHUTENGO",
        "solicitante": "FERNANDO VARGAS MALDONADO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AEGM690326HHGRRG07",
        "camino": "LOMA LA PAREJA-SANTA MARÍA ",
        "municipio": "SAN AGUSTÍN METZQUITITLAN",
        "localidad": "LOMA LA PAREJA",
        "solicitante": "MIGUEL ARELLANO GARCÍA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AOPM961120MHGNLG04",
        "camino": "ZAHUASTIPAN-TZICOATIAN",
        "municipio": "SAN AGUSTÍN METZQUITITLAN",
        "localidad": "ZAHUASTIPAN",
        "solicitante": "MAGALY ANTONIO PALACIOS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SASL710510MHGLLN04",
        "camino": "ACCESO HUIZACHEZ-MANDHO CERRO PRIETO ",
        "municipio": "TASQUILLO",
        "localidad": "HUIZACHEZ",
        "solicitante": "LEONOR SALDAÑA SALDAÑA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RARP020528MHGMNLA9",
        "camino": "AV. TAMARINDO-TLALPAN-PLUTARCO ELÍAS CALLES",
        "municipio": "ZIMAPÁN",
        "localidad": "TLALPAN",
        "solicitante": "PAOLA ANAID RAMÍREZ RANGEL",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "JIRB770520HHGMLR06",
        "camino": "EL PARAÍSO-RIO BLANCO",
        "municipio": "HUEHUETLA",
        "localidad": "RIO BLANCO",
        "solicitante": "BERNARDINO JIMÉNEZ ROLDAN",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SOCG671215MHGLSR01",
        "camino": "HUASQUILLA-ORATORIA",
        "municipio": "SAN BARTOLO TUTOTEPEC",
        "localidad": "HUASQUILLA",
        "solicitante": "GEORGINA SOLÍS CASTELÁN",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GOAJ830824MHGMMN09",
        "camino": "LA MESA-MEDIA CUESTA",
        "municipio": "SAN BARTOLO TUTOTEPEC",
        "localidad": "LA MESA",
        "solicitante": "JUANA GÓMEZ AMADOR",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MATL790421HHGNLR07",
        "camino": "LOS NOGALES-SANTA INÉS",
        "municipio": "HUEHUETLA",
        "localidad": "SANTA INÉS",
        "solicitante": "LORENZO MANRIQUE TOLENTINO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "ROPP991215HHGMRD01",
        "camino": "SAN JUAN-LA VENTA",
        "municipio": "SAN BARTOLO TUTOTEPEC",
        "localidad": "SAN JUAN",
        "solicitante": "PEDRO ALONSO ROMERO PEREA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MACF970415HHGDSL06",
        "camino": "EL CANJOY-LAESPERANZA",
        "municipio": "SAN BARTOLO TUTOTEPEC",
        "localidad": "EL CANJOY",
        "solicitante": "FLORIBERTO MADERO CASTILLO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CAVV971208HHGSLC03",
        "camino": "LA SABANA-LA LOMA-EL VEINTE",
        "municipio": "SAN BARTOLO TUTOTEPEC",
        "localidad": "LA SABANA",
        "solicitante": "VÍCTOR CASTRO VELASCO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "TOCA890727HHGLRD07",
        "camino": "SAN MIGUEL -LA HUAHUA",
        "municipio": "SAN BARTOLO TUTOTEPEC",
        "localidad": "SAN MIGUEL",
        "solicitante": "ADRIÁN TOLENTINO DE LA CRUZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CICE700820HHGPBL02",
        "camino": "EL MEZQUITE-EL PIRÚ",
        "municipio": "METZTITLÁN",
        "localidad": "EL TABLÓN",
        "solicitante": "ELÍAS CIPRÉS CABRERA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MEDJ911218MHGLRD01",
        "camino": "ACCESO A SAN FELIPE",
        "municipio": "MINERAL DEL MONTE",
        "localidad": "SAN FELIPE",
        "solicitante": "JUDITH MELO DURAN",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MAPA730202HHGRRL05",
        "camino": "CALLE MORELOS",
        "municipio": "IXMIQUILPAN",
        "localidad": "EL DURAZNO",
        "solicitante": "ALEJANDRO MARTÍNEZ PÉREZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEHR710106HHGRRY22",
        "camino": "ACCESO A POXTLA",
        "municipio": "HUEJUTLA DE REYES",
        "localidad": "POXTLA",
        "solicitante": "REYES HERNÁNDEZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CUDA660512MHGRNT01",
        "camino": "ACCESO A LA CUCHILLA",
        "municipio": "ZEMPOALA",
        "localidad": "LA CUCHILLA",
        "solicitante": "ATILANA CRUZ DANIEL",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SAMA800408HHGNRL07",
        "camino": "TLAJOMULCO-SANTO TOMAS",
        "municipio": "ZEMPOALA",
        "localidad": "SANTO TOMAS",
        "solicitante": "ALBERTO SANTILLÁN MORENO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GOHH861012MHGDRD03",
        "camino": "SAN PABLO-CERRITOS",
        "municipio": "HUASCA DE OCAMPO",
        "localidad": "SAN PABLO",
        "solicitante": "MARÍA HEIDI GODÍNEZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CATL990915MHGSRB01",
        "camino": "AL CANAL DE RIEGO",
        "municipio": "TASQUILLO",
        "localidad": "SAN MIGUEL",
        "solicitante": "LIBERTAD CAS BLANCA TORIBIO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HERL920803MHGRYD06",
        "camino": "CRUCERO OJO DE AGUA-CANTARRANAS",
        "municipio": "HUASCA DE OCAMPO",
        "localidad": "OJO DE AGUA",
        "solicitante": "LIDIA YARETH HERNÁNDEZ REYES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "OIGM800228MHGRMN04",
        "camino": "CALLE PRINCIPAL EL REPARÓ",
        "municipio": "ZACUALTIPÁN DE ÁNGELES",
        "localidad": "EL REPARO",
        "solicitante": "MINERVA ORTIZ GÓMEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "LOMA610553MHGPNN10",
        "camino": "LOMA BONITA",
        "municipio": "AJACUBA",
        "localidad": "VICENTE GUERRERO",
        "solicitante": "MARÍA DE LOS ÁNGELES LÓPEZ MENDOZA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "QURV700518HHGNJN03",
        "camino": "LOMA DEL BORREGO",
        "municipio": "TEPEJI DEL RIO",
        "localidad": "DOS PEÑAS",
        "solicitante": "VENANCIO QUINTANAR ROJO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HIGP731004HMCLRD09",
        "camino": "CALLE 16 DE ENERO-CALLE FRANCISCO GARCÍA ISLAS",
        "municipio": "ZEMPOALA",
        "localidad": "EL MIRADOR",
        "solicitante": "PEDRO HILARIO GARCÍA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MAHL740327MHGRRD09",
        "camino": "COCHOTLA-ATLAPEXCO",
        "municipio": "ATLAPEXCO",
        "localidad": "COCHOTLA",
        "solicitante": "LIDIA MARTÍNEZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GOMN750221HHGNNP00",
        "camino": "EL ENZUELADO-LA PRESA",
        "municipio": "SAN AGUSTÍN METZQUITITLAN",
        "localidad": "TUZANAPA",
        "solicitante": "NAPOLEÓN GONZÁLEZ MONROY",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MOCA880312HHGRRL04",
        "camino": "CALLE JAVIER MINA",
        "municipio": "IXMIQUILPAN",
        "localidad": "SAN NICOLÁS",
        "solicitante": "ALONSO MORENO CRUZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PASG971229MHGDGB03",
        "camino": "MARIANO AZUETA",
        "municipio": "IXMIQUILPAN",
        "localidad": "SAN NICOLÁS",
        "solicitante": "GABRIELA PADRE SEGUNDO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GUFM650924HHGTLR28",
        "camino": "CUAUHTÉMOC",
        "municipio": "IXMIQUILPAN",
        "localidad": "SAN NICOLÁS",
        "solicitante": "J MERCED GUTIÉRREZ FLORES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEQD870524HHGRZN01",
        "camino": "CIRCUITO LUIS DONALDO COLOSIO",
        "municipio": "IXMIQUILPAN",
        "localidad": "SAN NICOLÁS",
        "solicitante": "DONACIANO HERNÁNDEZ QUEZADA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEBE090730HHGRTDA6",
        "camino": "1RA. AV. HIDALGO",
        "municipio": "IXMIQUILPAN",
        "localidad": "SAN NICOLÁS",
        "solicitante": "EDUARDO HERNÁNDEZ BAUTISTA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "IAGE821025HHGBTM03",
        "camino": "ANDRÉS IBARRA RDZ",
        "municipio": "IXMIQUILPAN",
        "localidad": "SAN NICOLÁS",
        "solicitante": "EMILIO IBARRA GUTIÉRREZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RACE740305HHGMHS00",
        "camino": "PONTIHU-ZIMAPAN",
        "municipio": "ZIMAPÁN",
        "localidad": "PONTIHU",
        "solicitante": "EUSEBIO RAMÍREZ CHÁVEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "IAPF740106HHGBRS05",
        "camino": "NIÑOS HÉROES",
        "municipio": "IXMIQUILPAN",
        "localidad": "SAN NICOLÁS",
        "solicitante": "JOSÉ FAUSTINO IBARRA PÉREZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "FOES690221HHGLSV06",
        "camino": "EMILIANO ZAPATA",
        "municipio": "IXMIQUILPAN",
        "localidad": "SAN NICOLÁS",
        "solicitante": "SEVERIANO FLORES ESTRADA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HETJ760501HHGRRS01",
        "camino": "LAURA ESQUIVEL",
        "municipio": "IXMIQUILPAN",
        "localidad": "SAN NICOLÁS",
        "solicitante": "JESÚS HERNÁNDEZ TREJO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SICC630304MHGMNS08",
        "camino": "1RA. CERRADA EFRÉN REBOLLEDO",
        "municipio": "IXMIQUILPAN",
        "localidad": "SAN NICOLÁS",
        "solicitante": "CASIMIRA SIMÓN CONTRERAS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HERA810609HHGRNN04",
        "camino": "FRIDA KAHLO",
        "municipio": "IXMIQUILPAN",
        "localidad": "SAN NICOLÁS",
        "solicitante": "ANTONIO HERNÁNDEZ RANGEL",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MACE850922HHGRRR01",
        "camino": "CALLE MANUEL DOBLADO",
        "municipio": "IXMIQUILPAN",
        "localidad": "SAN NICOLÁS",
        "solicitante": "ERICK MARCOS CRUZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GARE810718HHGRSD04",
        "camino": "CALLE JUAN DIEGO-CERRITOS",
        "municipio": "IXMIQUILPAN",
        "localidad": "SAN NICOLÁS",
        "solicitante": "EDGAR GARCÍA RESÉNDIZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SATA761130MMSLPN07",
        "camino": "EL COMANCHE-VENTA DE GUADALUPE",
        "municipio": "OMITLÁN DE JUÁREZ",
        "localidad": "EL COMANCHE",
        "solicitante": "ANDREA SALINAS TAPIA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "DUGJ010214MHGRRVA8",
        "camino": "CIRCUITO CAMPO DE FUTBOL MANUEL TENIENTE",
        "municipio": "OMITLÁN DE JUÁREZ",
        "localidad": "MANUEL TENIENTE",
        "solicitante": "JOVANA DURAN GUERRERO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "IAGP880317MHGSZT08",
        "camino": "CIÉNEGA GRANDE-CRUZ DE MADROÑO",
        "municipio": "OMITLÁN DE JUÁREZ",
        "localidad": "CRUZ DE MADROÑO",
        "solicitante": "PATRICIA ISLAS GUZMÁN",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MUFD940730MHGNRL06",
        "camino": "CERRO GORDO-CRUZ DE MUJER",
        "municipio": "OMITLÁN DE JUÁREZ",
        "localidad": "CERRO GORDO",
        "solicitante": "DULCE IVETH MUNGUÍA FRAGOSO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SABJ711124MHGNRN00",
        "camino": "EL TEJOCOTE-GUERRERO",
        "municipio": "OMITLÁN DE JUÁREZ",
        "localidad": "EL TEJOCOTE",
        "solicitante": "JUANA SÁNCHEZ BRITO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SAPA900212MHGLLL03",
        "camino": "CALLE ÁRNICA",
        "municipio": "OMITLÁN DE JUÁREZ",
        "localidad": "VENTA DE GUADALUPE",
        "solicitante": "MARÍA ALEJANDRA SALINAS PALAFOX",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CAPM890826HHGBLG09",
        "camino": "EL MANZANO-LAGUNILLA",
        "municipio": "OMITLÁN DE JUÁREZ",
        "localidad": "EL MANZANO",
        "solicitante": "MIGUEL CABRERA PALAFOX",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MERC870406HHGLSL02",
        "camino": "LAGUNILLA-MANZANO",
        "municipio": "OMITLÁN DE JUÁREZ",
        "localidad": "LA LAGUNILLA",
        "solicitante": "CELESTINO MELO RÍOS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MABZ751221MJCLCL05",
        "camino": "MIXQUIAPAN",
        "municipio": "OMITLÁN DE JUÁREZ",
        "localidad": "MIXQUIAPAN",
        "solicitante": "ZULEIKA ISABEL MALDONADO BECERRA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PEGA030109MHGRMDA9",
        "camino": "CIÉNEGA GRANDE",
        "municipio": "OMITLÁN DE JUÁREZ",
        "localidad": "CIÉNEGA GRANDE",
        "solicitante": "ADRIANA PÉREZ GÓMEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "VAOJ000217HHGZRSA4",
        "camino": "CRUZ DE OMITLÁN-MANUEL TENIENTE",
        "municipio": "OMITLÁN DE JUÁREZ",
        "localidad": "CRUZ DE OMITLÁN",
        "solicitante": "JESÚS VÁZQUEZ ORDAZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CAZV880916HHGBMC09",
        "camino": "MORELOS-EL MANZANO",
        "municipio": "OMITLÁN DE JUÁREZ",
        "localidad": "EL MANZANO",
        "solicitante": "VÍCTOR HUGO CABRERA ZAMORA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BAPA740710HHGTRL03",
        "camino": "CAMINO PRINCIPAL A LA PRIMARIA",
        "municipio": "ACTOPAN",
        "localidad": "SAUCILLO",
        "solicitante": "ALEJANDRO BAUTISTA PÉREZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "DUGJ010214MHGRRVA8",
        "camino": "LAS ANTENAS DE MANUEL TENIENTE",
        "municipio": "OMITLÁN DE JUÁREZ",
        "localidad": "MANUEL TENIENTE",
        "solicitante": "JOVANA DURAN GUERRERO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MABZ751221MJCLCL05",
        "camino": "EL TECOLOTE",
        "municipio": "OMITLÁN DE JUÁREZ",
        "localidad": "MIXQUIAPAN",
        "solicitante": "ZULEIKA ISABEL MALDONADO BECERRA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "JUGM810729MHGRZR03",
        "camino": "VELAZCO-RINCÓN CHICO-CUCHILAPAN",
        "municipio": "OMITLÁN DE JUÁREZ",
        "localidad": "RINCÓN CHICO",
        "solicitante": "MARTHA JUÁREZ GUZMÁN",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "OEVL891029HHGLRS08",
        "camino": "NUEVA IGLESIA SRA. DE LOS ÁNGELES",
        "municipio": "OMITLÁN DE JUÁREZ",
        "localidad": "TRES CAÑADAS",
        "solicitante": "JOSÉ LUIS OLVERA VARGAS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RALG720930HHGMBR08",
        "camino": "PEMUCHE-AGUACATE",
        "municipio": "PISAFLORES",
        "localidad": "EL PEMUCHE",
        "solicitante": "GERÓNIMO RAMOS LOBATÓN",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MAFR660630HHGRRB00",
        "camino": "EL POTRERO-MONTE GRANDE",
        "municipio": "SAN FELIPE ORIZATLÁN",
        "localidad": "EL POTRERO",
        "solicitante": "RUBÉN MARTÍNEZ FERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEHF750506HHGRRL01",
        "camino": "APATZINTLA-HUEXTETITLA",
        "municipio": "SAN FELIPE ORIZATLÁN",
        "localidad": "APATZINTLA",
        "solicitante": "FILOGONIO HERNÁNDEZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GABD641220HHGRZM00",
        "camino": "MONTE GRANDE-EL BRASILAR",
        "municipio": "SAN FELIPE ORIZATLÁN",
        "localidad": "MONTE GRANDE",
        "solicitante": "DOMINGO GARCÍA BAIZA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GAHH751102HHGRRR04",
        "camino": "POTRERO-PANTEÓN",
        "municipio": "SAN FELIPE ORIZATLÁN",
        "localidad": "EL POTRERO",
        "solicitante": "HORACIO GRANDE HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEHC670629HHGRRR13",
        "camino": "COAMAXTLA",
        "municipio": "SAN FELIPE ORIZATLÁN",
        "localidad": "TEPETZINTLA II",
        "solicitante": "CRESCENCIO HERNÁNDEZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEHM780115HHGRRC07",
        "camino": "EL CARRIZAL-SAN FELIPE ORIZATLÁN",
        "municipio": "SAN FELIPE ORIZATLÁN",
        "localidad": "EL CARRIZAL",
        "solicitante": "MACARIO HERNÁNDEZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEZA520711HHGRXL08",
        "camino": "TANTOYUQUITA-GLOJITE",
        "municipio": "SAN FELIPE ORIZATLÁN",
        "localidad": "TANTOYUQUITA",
        "solicitante": "ALBERTO HERNÁNDEZ ZÚÑIGA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEHJ751216HHGRRL02",
        "camino": "EL CARRIZAL",
        "municipio": "SAN FELIPE ORIZATLÁN",
        "localidad": "EL CARRIZAL",
        "solicitante": "JULIO HERNÁNDEZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BAHJ861106HHGTRM09",
        "camino": "POHUANTITLA-ENTRADA PACHIQUITLA",
        "municipio": "XOCHIATIPAN",
        "localidad": "POHUANTITLA",
        "solicitante": "JAIME BAUTISTA HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PEPH640111HHGRRG06",
        "camino": "MONTE DE PIEDAD",
        "municipio": "TEZONTEPEC DE ALDAMA",
        "localidad": "NUEVO PAHUAYO",
        "solicitante": "HIGINIO PÉREZ PORRAS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "LARF730530HHGRVL05",
        "camino": "CAMINO REAL",
        "municipio": "HUEJUTLA DE REYES",
        "localidad": "CRUZTITLA",
        "solicitante": "FELIPE LARA RIVERA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BAMJ680809HHGRRR01",
        "camino": "PRINCIPAL IGLESIA-PANTEÓN",
        "municipio": "MOLANGO",
        "localidad": "XICHITLAN",
        "solicitante": "JORGE BARRERA MORALES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HESR770722HHGRNB02",
        "camino": "IXCUICUILA-SAN MIGUEL",
        "municipio": "MOLANGO",
        "localidad": "IXCUICUILA",
        "solicitante": "RUBISEL HERNÁNDEZ SÁNCHEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CUAE730219MHGRVL05",
        "camino": "LA RALLA",
        "municipio": "CARDONAL",
        "localidad": "SAN MIGUEL TLAZINTLA",
        "solicitante": "ELVIRA CRUZ AVALOS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "JAEJ810611HHGRSN03",
        "camino": "CARRETERA PRINCIPAL-POZO DE AGUA",
        "municipio": "TEPEAPULCO",
        "localidad": "LOS COYOTES",
        "solicitante": "JUAN CARLOS JARDINES ESPINOZA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RULES530427MHGBPV01",
        "camino": "LA PILA",
        "municipio": "JUÁREZ HIDALGO",
        "localidad": "JUÁREZ HIDALGO",
        "solicitante": "MARÍA EVELIA RUBIO LÓPEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HECF530501HHGRTR01",
        "camino": "ZACATLAN-NANAYATLA",
        "municipio": "XOCHIATIPAN",
        "localidad": "NANAYATLA",
        "solicitante": "FRANCISCO HERNÁNDEZ CATARINA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "LEMB020303MHGNRRA9",
        "camino": "REAL",
        "municipio": "EPAZOYUCAN",
        "localidad": "EL MARALLERO",
        "solicitante": "BRISEYDA GUADALUPE LEÓN MARCIAL",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "DUMV690131MHGRRR09",
        "camino": "PANTEON-BAXHI",
        "municipio": "CHAPANTONGO",
        "localidad": "BATHI",
        "solicitante": "VIRGINIA DURAN MARTÍNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEPA981216HHGRRR05",
        "camino": "CALLE PRINCIPAL BARRIO CENTRO",
        "municipio": "METZTITLÁN",
        "localidad": "ITZTAZACUALA",
        "solicitante": "JOSÉ ARTURO HERNÁNDEZ PÉREZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PEPA880205HHGRRL09",
        "camino": "LAS MECAS",
        "municipio": "ACTOPAN",
        "localidad": "LAS MECAS",
        "solicitante": "ALFREDO PÉREZ PORTILLO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "EUMD680615HHGSRM01",
        "camino": "ACCESO MATLATLAH",
        "municipio": "ZACUALTIPÁN DE ÁNGELES",
        "localidad": "MATLATLAH",
        "solicitante": "DOMINGO ANASTACIO ESCUDERO MERCADO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEMH580520HHGRNL04",
        "camino": "CERRO ALTO-CIMBRONES",
        "municipio": "MINERAL DEL CHICO",
        "localidad": "CERRO ALTO",
        "solicitante": "HILARIO HERRERA MONTES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MOCC820617MHGRRR03",
        "camino": "HOMBRES ILUSTRES",
        "municipio": "SAN SALVADOR",
        "localidad": "SAN ANTONIO ZARAGOZA",
        "solicitante": "MARÍA DEL CARMEN MORENO CERVANTES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "TETI890124HHGRLV05",
        "camino": "SAN ESTEBAN-JUNTAS CHICAS",
        "municipio": "HUEHUETLA",
        "localidad": "SAN ESTEBAN",
        "solicitante": "IVÁN TREJO TOLENTINO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "TOMA780930HHGMRN00",
        "camino": "CUXHUACAN-ACAYUCA",
        "municipio": "MOLANGO",
        "localidad": "CUXHUACAN",
        "solicitante": "ANTONIO TOMAS MARIANO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "TECF870510HHGLRL06",
        "camino": "BARRIO CERRO VERDE-BARRIO TAMPICO",
        "municipio": "ACAXOCHITLÁN",
        "localidad": "ZOTICTLA",
        "solicitante": "FLORENCIO TÉLLEZ CRUZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GACL810526HHGLRS06",
        "camino": "CARDONALITO-VITHE",
        "municipio": "CARDONAL",
        "localidad": "CARDONALITO",
        "solicitante": "JOSÉ LUIS GALLARDO CRUZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MEVS751217HHGDTR09",
        "camino": "TLAHUELOMPA-XALTIPA",
        "municipio": "TLANCHINOL",
        "localidad": "TLAHUELOMPA",
        "solicitante": "SERGIO MEDINA VITE",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "TESG540106HHGLMS00",
        "camino": "CIRCUNVALACIÓN NORTE-REAL TLANALAPA-TEPEAPULCO",
        "municipio": "TLANALAPA",
        "localidad": "BONHI",
        "solicitante": "GASPAR TÉLLEZ SAMPERIO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "OERP590220HTLRDD02",
        "camino": "SAN JUAN AHUAYALULCO",
        "municipio": "TLANALAPA",
        "localidad": "TLANALAPA",
        "solicitante": "JOSÉ PEDRO ORTEGA RODRÍGUEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CARA750805HHGSMB03",
        "camino": "AV. DEL TRABAJO",
        "municipio": "TLANALAPA",
        "localidad": "SAN VICENTE",
        "solicitante": "ABEL CASTILLO ROMERO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "COQR870616HHGRTB00",
        "camino": "SANTA CECILIA",
        "municipio": "IXMIQUILPAN",
        "localidad": "IGNACIO LÓPEZ RAYÓN",
        "solicitante": "RUBÉN CORONA QUITERIO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CICD911210MSLHRN07",
        "camino": "CALLE EL CAPULÍN",
        "municipio": "TEPEJI DEL RIO",
        "localidad": "SAN JOSÉ PIEDRA GORDA",
        "solicitante": "DENISSE EDELMIRA CHIQUETE CRUZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEBG760525HHGRTR09",
        "camino": "AV. CANTERA Y AV. XICUCO",
        "municipio": "TEZONTEPEC DE ALDAMA",
        "localidad": "CERRO DEL XICUCO",
        "solicitante": "GREGORIO HERNÁNDEZ BAUTISTA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "TEMH660325HHGRRM06",
        "camino": "CALLE CENTRO",
        "municipio": "ZIMAPÁN",
        "localidad": "LA SABINA",
        "solicitante": "HUMBERTO TREJO MARTÍNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RIMH840528HHGVRC03",
        "camino": "ETAPA 1 CENTRO",
        "municipio": "CARDONAL",
        "localidad": "EL POTRERO",
        "solicitante": "HÉCTOR RIVERA MARTÍNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MOCJ830531MHGRRS07",
        "camino": "MIRAFLORES-OJO DE AGUA",
        "municipio": "PISAFLORES",
        "localidad": "MIRAFLORES",
        "solicitante": "MARÍA DE JESÚS MORALES CERVANTES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AEVJ600809HHGNRN05",
        "camino": "LA VEREDA",
        "municipio": "METZTITLÁN",
        "localidad": "PIE DE LA CUESTA",
        "solicitante": "JUAN ÁNGELES VARGAS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SASC720807MHGNLR21",
        "camino": "ENTRONQUE BONIGU-SAN PEDRO",
        "municipio": "PISAFLORES",
        "localidad": "SAN PEDRO XOCHICUACO",
        "solicitante": "MA. DEL CARMEN SAINS SALVADOR",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GORA721107HSPNMQ00",
        "camino": "PLAN DE ZAPOTAL-RIO TANCUILIN",
        "municipio": "PISAFLORES",
        "localidad": "PLAN DE ZAPOTAL",
        "solicitante": "AQUILEO GONZÁLEZ RAMÍREZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEMB940403HHGRRN08",
        "camino": "BARRIO BAJO, TRAMO LA AGÜITA",
        "municipio": "PISAFLORES",
        "localidad": "EL GARABATO",
        "solicitante": "BIONERI HERNÁNDEZ MORENO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CABG751030HHGSSR07",
        "camino": "LA PIMIENTA-TALOL",
        "municipio": "TLANCHINOL",
        "localidad": "LA PIMIENTA",
        "solicitante": "GERMAN CASTRO BUSTOS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RUAF911014MHGBNR05",
        "camino": "ACCESO A EL CUAMIRRO",
        "municipio": "PISAFLORES",
        "localidad": "EL CUAMIRRO",
        "solicitante": "FORTUNATA RUBIO ANDABLO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MAZA930717MHGRRN01",
        "camino": "LA LAGUNA-CASAS VIEJAS",
        "municipio": "PISAFLORES",
        "localidad": "LA LAGUNA",
        "solicitante": "ANA MARÍA MARTEL ZARAZÚA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AORT771114HHGCVM04",
        "camino": "AGUACATLAN",
        "municipio": "CARDONAL",
        "localidad": "AGUACATLAN",
        "solicitante": "TOMAS ACOSTA RIVERA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEFJ670131HHGRLV05",
        "camino": "IXTLAPALA-TETLAPAYA",
        "municipio": "TLANCHINOL",
        "localidad": "IXTLAPALA",
        "solicitante": "JAVIER HERNÁNDEZ FELIPE",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CAMR891229HHGHJB03",
        "camino": "CAMINO VIEJO-EL TESORO",
        "municipio": "HUICHAPAN",
        "localidad": "EL CAJÓN",
        "solicitante": "ROBERTO CHÁVEZ MEJÍA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GOMC830909HHGNRR02",
        "camino": "SAN ANTONIO TEZOQUIPAN-NINTHI",
        "municipio": "ALFAJAYUCAN",
        "localidad": "SAN ANTONIO TEZOQUIPAN",
        "solicitante": "CARLOS GONZÁLEZ MARIANO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SAHL790419HHGNRN04",
        "camino": "ACCESO A EL COYOL",
        "municipio": "PISAFLORES",
        "localidad": "EL COYOL",
        "solicitante": "LEONARDO SÁNCHEZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AECS600103HHGVL07",
        "camino": "PUERTO CHICO",
        "municipio": "SAN SALVADOR",
        "localidad": "PUERTO LÁZARO CÁRDENAS",
        "solicitante": "SALVADOR AVENDAÑO CRUZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GUME801226HHGZRS03",
        "camino": "EL VUELO DE LAS ÁGUILAS",
        "municipio": "OMITLÁN DE JUÁREZ",
        "localidad": "MORELOS",
        "solicitante": "ESTEBAN GUZMÁN MORALES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MARK950529MHGRBR00",
        "camino": "LA ESPERANZA",
        "municipio": "PISAFLORES",
        "localidad": "CHLAHUITE",
        "solicitante": "KARINA MARTÍNEZ ROBLES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MEOR830809HSPDLF07",
        "camino": "OJO DE AGUA-LA PECHUGA",
        "municipio": "PISAFLORES",
        "localidad": "OJO DE AGUA",
        "solicitante": "RAFAEL MEDINA OLGUIN",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GALC820514HHGRPS05",
        "camino": "EL MEJAY-LA ESTANCIA",
        "municipio": "CHILCUAUTLA",
        "localidad": "EL MEJAY",
        "solicitante": "CESAR DAVID GARCÍA LÓPEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "REVB840102HHGYLS01",
        "camino": "ENTRONQUE TLANCHINOL-TIANGUISPICULA-PITZOTLA",
        "municipio": "TLANCHINOL",
        "localidad": "PITZOTLA",
        "solicitante": "BASILIO REYES VALDIVIA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PEBM670329HHGRRR02",
        "camino": "PUERTO OSCURO",
        "municipio": "PISAFLORES",
        "localidad": "PUERTO OSCURO",
        "solicitante": "MARIANO PÉREZ BARRERA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "VARI750501MHGRBM08",
        "camino": "SANTO DOMINGO",
        "municipio": "NICOLÁS FLORES",
        "localidad": "SANTO DOMINGO",
        "solicitante": "IMELDA VARDAS ROBLES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PALJ880722HHGBRS05",
        "camino": "OTECOCH-COPALTITLA",
        "municipio": "HUAZALINGO",
        "localidad": "OTECOCH",
        "solicitante": "JOSÉ PABLO LARA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "FELE630618HHGRNF07",
        "camino": "ACUAPA-PILCUATLA",
        "municipio": "TLANCHINOL",
        "localidad": "ACUAPA",
        "solicitante": "EFRÉN FERNÁNDEZ LANGARTE",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MEHB790101MHGLRL03",
        "camino": "CASAS VIEJAS-BUNIGÜ",
        "municipio": "PISAFLORES",
        "localidad": "CASAS VIEJAS",
        "solicitante": "BLANCA ESTELA MELO HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CXCA700515MHGBRL05",
        "camino": "EL ARBOLITO",
        "municipio": "ACTOPAN",
        "localidad": "EL BOXTHA",
        "solicitante": "ALICIA CABALLERO CERÓN",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GOAB790721MHGNGR07",
        "camino": "CALLE 2 DE MARZO",
        "municipio": "FRANCISCO I. MADERO",
        "localidad": "SAN JOSÉ BOXAY",
        "solicitante": "BERTHA YARELY GONZÁLEZ AGUILAR",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MEGJ710423HHGJMR05",
        "camino": "CALLE 4 DE MARZO",
        "municipio": "FRANCISCO I. MADERO",
        "localidad": "LA MORA",
        "solicitante": "JORGE MEJÍA GÓMEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "REPM841227MHGYDR09",
        "camino": "AV. LOS PIRULES",
        "municipio": "TLAXCOAPAN",
        "localidad": "TELTIPAN DE JUÁREZ",
        "solicitante": "MARLEN REYES PEDRAZA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SAHG911206MHGNDB08",
        "camino": "4TA CERRADA GRAN CANAL",
        "municipio": "TLAXCOAPAN",
        "localidad": "TELTIPAN DE JUÁREZ",
        "solicitante": "GABRIELA SÁNCHEZ HIDALGO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GOHE860404HHGNRD08",
        "camino": "EL ABREVADERO-EMILIANO ZAPATA",
        "municipio": "TLAXCOAPAN",
        "localidad": "DOXEY",
        "solicitante": "EDUARDO NOE GONZÁLEZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RAAI800514MDFMRV08",
        "camino": "CALLE FRESNO",
        "municipio": "ACTOPAN",
        "localidad": "LA ESTANCIA",
        "solicitante": "IVONNE RAMÍREZ ARIZMENDI",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CAFT791031MHGLRR06",
        "camino": "CALLE PIRULES",
        "municipio": "ACTOPAN",
        "localidad": "LA ESTANCIA",
        "solicitante": "TERESA CALVA FRAGOSO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "EIGR841001HHGSTB02",
        "camino": "LA CAÑADA",
        "municipio": "ACTOPAN",
        "localidad": "LA ESTANCIA",
        "solicitante": "ROBERTO ESPINOZA GUTIÉRREZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HESR771219HHGRGD04",
        "camino": "CALLE JACARANDAS",
        "municipio": "ACTOPAN",
        "localidad": "LA ESTANCIA",
        "solicitante": "RODRIGO ARMANDO HERNÁNDEZ SEGURA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CUHG900418HHGRRL07",
        "camino": "S/N",
        "municipio": "ACAXOCHITLÁN",
        "localidad": "SANTA ANA TZACUALA",
        "solicitante": "GALDINO CRUZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "REAJ900304MHGBNS03",
        "camino": "MILPA GRANDE-AGUA HEDEONDA",
        "municipio": "METZTITLÁN",
        "localidad": "MILPA GRANDE",
        "solicitante": "JOSEFINA REBOLLEDO ÁNGELES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CAHF640718HHGTRS02",
        "camino": "PRINCIPAL XOCHITLÁN DOTZIBI",
        "municipio": "PROGRESO DE OBREGÓN",
        "localidad": "XOCHITLÁN DOTZIBI",
        "solicitante": "FAUSTINO CATALÁN HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MAPR630819HHGRRM07",
        "camino": "NTUZPA",
        "municipio": "CHILCUAUTLA",
        "localidad": "EL BETHI",
        "solicitante": "ROMÁN MARTIN PÉREZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MAPR630819HHGRRM07",
        "camino": "LA PALMA",
        "municipio": "CHILCUAUTLA",
        "localidad": "EL BETHI",
        "solicitante": "ROMÁN MARTIN PÉREZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CUSP840409HVZRNR02",
        "camino": "ACCESO SAN FRANCISCO",
        "municipio": "SAN AGUSTÍN METZQUITITLAN",
        "localidad": "SAN FRANCISCO",
        "solicitante": "PRÓCORO CRUZ SÁNCHEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GOBC820425HHGNZL01",
        "camino": "SANTIAGUITO",
        "municipio": "ATOTONILCO EL GRANDE",
        "localidad": "SANTIAGUITO",
        "solicitante": "CELATIEL GONZÁLEZ BAZÁN",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MARG760105MHGRMD06",
        "camino": "CIRCUITO SANTANDER-CAMINO REAL",
        "municipio": "TASQUILLO",
        "localidad": "REMEDIOS",
        "solicitante": "MARÍA GUADALUPE MARTÍNEZ RAMÍREZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GASM920212HHGRND04",
        "camino": "AV. REVOLUCIÓN",
        "municipio": "TEPEJI DEL RIO",
        "localidad": "SANTA MARÍA MAGDALENA",
        "solicitante": "MADISSON GRANADOS SANDOVAL",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RAPN920116HHGMRX03",
        "camino": "ACCESO HUITZILINGO",
        "municipio": "ACAXOCHITLÁN",
        "localidad": "PAREDONES",
        "solicitante": "NOE RAMOS PEREA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GACJ750608HHGBRR02",
        "camino": "TLALTEPINGO-CRUCERO HUITZNOPALA",
        "municipio": "LOLOTLA",
        "localidad": "TLALTEPINGO",
        "solicitante": "JORGE GABRIEL CORDERO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "REPV650927HHGNRC07",
        "camino": "CHILE-TECOLOTE",
        "municipio": "ATOTONILCO EL GRANDE",
        "localidad": "SANTA MARÍA AMAJAC",
        "solicitante": "VICENTE RENDON PÉREZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "JIRA590417HHGMVN02",
        "camino": "COYOL-SAUCILLO",
        "municipio": "CHAPULHUACAN",
        "localidad": "EL COYOL",
        "solicitante": "ANICETO JIMÉNEZ RIVERA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SIAB730824HHHGMNR09",
        "camino": "LIBRAMIENTO AGUACATLAN-PALMAR-SAN ANDRÉS MIRAFLORES",
        "municipio": "CARDONAL",
        "localidad": "CIENEGUILLA",
        "solicitante": "BARTOLO SIMÓN ÁNGELES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "ROEA630111HHGDLL01",
        "camino": "CARLOTA",
        "municipio": "TLANALAPA",
        "localidad": "RANCO SAN GREGORIO",
        "solicitante": "ALEJANDRO RODRÍGUEZ ELIZALDE",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "LEMS730821HHGCDL07",
        "camino": "SAN PEDRO-PILCUAUTLA",
        "municipio": "TLANCHINOL",
        "localidad": "PILCUAUTLA",
        "solicitante": "SILVANO LECHUGA MODESTO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CATK000115MPLBRMA1",
        "camino": "ACCESO AGUACATITO-PRIMARIA",
        "municipio": "ZIMAPÁN",
        "localidad": "EL AGUACATITO",
        "solicitante": "KIMBERLY AIDÉ CABRERA TREJO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEUI950827HHGRRV09",
        "camino": "BARRIO LA MESA-ESC. TEXCADHO",
        "municipio": "NICOLÁS FLORES",
        "localidad": "TEXCADHO",
        "solicitante": "IVÁN HERNÁNDEZ URBANO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GOCI780221HHGNRS07",
        "camino": "SEGUNDA LOMA DOTHU-CERRO DE LA CRUZ",
        "municipio": "NICOLÁS FLORES",
        "localidad": "DOTHU",
        "solicitante": "ISRAEL GONZÁLEZ CRISTÓBAL",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "OUBK930212HHGLLL09",
        "camino": "ACCESO BARRIO SEGUNDO CENTRO",
        "municipio": "NICOLÁS FLORES",
        "localidad": "SEGUNDO CENTRO",
        "solicitante": "KELVIN OLGUIN BELTRÁN",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BAHN770318HHGTRR04",
        "camino": "ZACAYAHUAL",
        "municipio": "YAHUALICA",
        "localidad": "ZACAYAHUAL",
        "solicitante": "NARCIZO BAUTISTA HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "OOLL550723HHGRPB15",
        "camino": "CAMINO VIEJO A SAN JUAN",
        "municipio": "APAN",
        "localidad": "SAN JOSÉ EL MIRADOR",
        "solicitante": "LIBORIO ORDOÑEZ LÓPEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "META691215HHGNLR02",
        "camino": "CALLE CEDRO-12 DE DICIEMBRE",
        "municipio": "PACHUCA",
        "localidad": "SANTIAGO TLAPACOYA",
        "solicitante": "ARTURO MÉNDEZ TÉLLEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SAMC770511HHGNRR01",
        "camino": "CIRCUITO PROFA. EVANGELINA FEDERICO MARTÍNEZ",
        "municipio": "NICOLÁS FLORES",
        "localidad": "TEDRA",
        "solicitante": "CARLOS AUGUSTO SANTANA MARTÍNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "EARR980416HHGSMN09",
        "camino": "EL COBRE-MESA DE LA CEBADA",
        "municipio": "NICOLÁS FLORES",
        "localidad": "EL COBRE",
        "solicitante": "RENE ESTRADA ROMERO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SATQ800430MHGNLR03",
        "camino": "BRECHA NO. 1",
        "municipio": "NICOLÁS FLORES",
        "localidad": "SANTA CRUZ",
        "solicitante": "QUIRINA SANTOS TÉLLEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "ROSL000112MHGSNZA7",
        "camino": "19 DE MARZO",
        "municipio": "FRANCISCO I. MADERO",
        "localidad": "SAN JOSÉ BOXAY",
        "solicitante": "LIZBETH ROSAS SANTIAGO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CUMM500213HHGRJR05",
        "camino": "17 DE MARZO",
        "municipio": "FRANCISCO I. MADERO",
        "localidad": "SAN JOSÉ BOXAY",
        "solicitante": "MAURO CRUZ MEJÍA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "LOHA730829HHGPRD23",
        "camino": "EL ÁGUILA-PANTEÓN DE LOS ÁNGELES",
        "municipio": "HUASCA DE OCAMPO",
        "localidad": "OJO DE AGUA",
        "solicitante": "ADÁN LÓPEZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RORM890928HHGMMG06",
        "camino": "CAMARONES-SAN JUAN AMAJAQUE",
        "municipio": "TLAHUILTEPA",
        "localidad": "CAMARONES",
        "solicitante": "MIGUEL ROMERO RAMÍREZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SOHC731102HHGTRR06",
        "camino": "LOS PINOS-OJO DE AGUA",
        "municipio": "HUASCA DE OCAMPO",
        "localidad": "OJO DE AGUA",
        "solicitante": "CIRILO SOTO HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CASO780224HHGLTS02",
        "camino": "SAN IGNACIO-HUEYAPAN",
        "municipio": "HUASCA DE OCAMPO",
        "localidad": "SAN IGNACIO",
        "solicitante": "OSCAR MANUEL CALDERÓN SOTO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BADM590608MHGRMX08",
        "camino": "CALLE PRINCIPAL YERBABUENA",
        "municipio": "HUASCA DE OCAMPO",
        "localidad": "YERBABUENA",
        "solicitante": "MARÍA MAXIMINA BARRÓN DIMAS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "FEME781220MDFRRL02",
        "camino": "EL ARCO-LA CAPILLA",
        "municipio": "EL ARENAL",
        "localidad": "SAN JERÓNIMO",
        "solicitante": "ELVIA SANDRA FERNÁNDEZ MARTÍNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BAAR690809HHGTLG09",
        "camino": "ACCESO A SANTO TOMAS",
        "municipio": "ATLAPEXCO",
        "localidad": "SANTO TOMAS",
        "solicitante": "ROGELIO BAUTISTA ÁLVAREZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "EOEC570803HHGSSR07",
        "camino": "ACCESO PRINCIPAL CENTRO",
        "municipio": "HUASCA DE OCAMPO",
        "localidad": "OJO DE AGUA",
        "solicitante": "CIRO ESCORZA ESCORZA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "EIFA530829HHGSND07",
        "camino": "ACCESO A EL LLANO",
        "municipio": "TASQUILLO",
        "localidad": "EL LLANO",
        "solicitante": "ADOLFO ESPINOZA FUENTES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "ROMR770729MHGSRS07",
        "camino": "BOXTHA CHICO-LA LAGUNILLA",
        "municipio": "SAN SALVADOR",
        "localidad": "BOXTHA CHICO",
        "solicitante": "ROSALVA ROSAS MARTÍNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PAZM630922HHGRXR05",
        "camino": "AV. LA MESA",
        "municipio": "EL ARENAL",
        "localidad": "EL RINCÓN",
        "solicitante": "MAURICIO PAREDES ZÚÑIGA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MAHR670418HHGRRM02",
        "camino": "XANCALTITLA-BALCON",
        "municipio": "ATLAPEXCO",
        "localidad": "XANCALTITLA",
        "solicitante": "RAMÓN MARTÍNEZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BAHF770222HHGTRL00",
        "camino": "TLACOECHAR-ZACATIPAN",
        "municipio": "TIANGUISTENGO",
        "localidad": "TLACOHECHAR",
        "solicitante": "FLORENCIO BAUTISTA HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HESC670507HHGRNL03",
        "camino": "ACCESO PALMA SOLA",
        "municipio": "SAN FELIPE ORIZATLÁN",
        "localidad": "PALMA SOLA",
        "solicitante": "CLAUDIO HERNÁNDEZ SÁNCHEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GOVA700705MHGNLN06",
        "camino": "PROLONGACIÓN 1° DE MAYO",
        "municipio": "TULA DE ALLENDE",
        "localidad": "EL DAMU",
        "solicitante": "ANTONIA GONZÁLEZ VILLEDA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEHN670424HHGRRC05",
        "camino": "LA LAJA-ORIZATLÁN-LAS PIEDRAS",
        "municipio": "SAN FELIPE ORIZATLÁN",
        "localidad": "LA LAJA",
        "solicitante": "NICOLÁS HERNÁNDEZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MEAA590916HHGRNL00",
        "camino": "CAMINO QUE CONECTA A LAS ESCUELAS",
        "municipio": "SAN FELIPE ORIZATLÁN",
        "localidad": "PIEDRA HINCADA",
        "solicitante": "ALONSO MERAZ ANTONIO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RAHS760503HHGMRN08",
        "camino": "CONECTA LA ESCUELA Y LA DELEGACIÓN",
        "municipio": "SAN FELIPE ORIZATLÁN",
        "localidad": "TEOXTITLA",
        "solicitante": "SANTIAGO RAMÍREZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HECA610824HHGRRG02",
        "camino": "ACCESO A POTEJAMEL",
        "municipio": "SAN FELIPE ORIZATLÁN",
        "localidad": "POTEJAMEL",
        "solicitante": "AGUSTÍN HERNÁNDEZ CORONEL",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "EIBC810916HHGNLP00",
        "camino": "ACCESO LOS ENCISOS",
        "municipio": "ZEMPOALA",
        "localidad": "SAN MATEO TLAJOMULCO",
        "solicitante": "CIPRIANO ENCISO BELLO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEHD711215HHGRRN07",
        "camino": "ATITIPA-CRUCERO POLINTOTLA",
        "municipio": "TIANGUISTENGO",
        "localidad": "XOCHIMILCO",
        "solicitante": "DANIEL HERNÁNDEZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GAES640829HHGRSB08",
        "camino": "CALLE LAS FLORES",
        "municipio": "MINERAL DEL MONTE",
        "localidad": "PUEBLO NUEVO",
        "solicitante": "SABINO GARCÍA ESPINOSA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BEGC680304MHGNRR09",
        "camino": "ARRIBA DE LA IGLESIA",
        "municipio": "MINERAL DEL MONTE",
        "localidad": "TEZOANTLA",
        "solicitante": "MARÍA CRUZ BENÍTEZ GARNICA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "REGV640518HHGNRN02",
        "camino": "SANTA ROSALÍA-LA PRESA",
        "municipio": "MINERAL DEL MONTE",
        "localidad": "SANTA ROSALÍA",
        "solicitante": "VENANCIO RENDÓN GARCÍA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "EOCC531223HCCGS01",
        "camino": "SAN ANTONIO-EL PASO",
        "municipio": "MINERAL DEL MONTE",
        "localidad": "SAN PEDRO HUIXOTITLA",
        "solicitante": "CESAR ESPONDA CIGARROA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MOAA750705MDFNRN01",
        "camino": "LLANO GRANDE",
        "municipio": "MINERAL DEL MONTE",
        "localidad": "TEZOANTLA",
        "solicitante": "ANA LILIA MONASTERIO ARMENTA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "VEAA040323HHGLMDA",
        "camino": "S/N",
        "municipio": "MINERAL DEL MONTE",
        "localidad": "SANTA ROSALÍA",
        "solicitante": "ADOLFO VELÁZQUEZ AMADOR",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BAAB650321HDFXGN06",
        "camino": "A UN COSTADO DE LA IGLESIA",
        "municipio": "MINERAL DEL MONTE",
        "localidad": "CIÉNEGA LARGA",
        "solicitante": "BENITO BAÑOS AGUILAR",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AARM740929HHGMZG09",
        "camino": "S/N",
        "municipio": "MINERAL DEL MONTE",
        "localidad": "SANTA ROSALÍA",
        "solicitante": "MIGUEL AMADOR RUIZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "VEGI690707MHGLRS04",
        "camino": "UN COSTADO DE LA IGLESIA",
        "municipio": "MINERAL DEL MONTE",
        "localidad": "TEZOANTLA",
        "solicitante": "MARÍA ISABEL VELÁZQUEZ GARNICA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GOAN890611MHGMNH04",
        "camino": "LLANO GRANDE",
        "municipio": "MINERAL DEL MONTE",
        "localidad": "TEZOANTLA",
        "solicitante": "NOHEMÍ GÓMEZ ANAYA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "VEJC650717MHGGMR00",
        "camino": "CTO. CAMPANARIO, CTO. SAN JOSÉ CAPULINES, CALLE EL RINCÓN, AV. SAN JUAN",
        "municipio": "EPAZOYUCAN",
        "localidad": "FRACC. XOCHIHUACAN",
        "solicitante": "CARMEN VEGA JIMÉNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RALE770908HHGMCD02",
        "camino": "BARRIO 8 (LA CABAÑA-CENTRO)",
        "municipio": "ACAXOCHITLÁN",
        "localidad": "LOS REYES",
        "solicitante": "EDGARDO RAMOS LICONA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MACG880212HHGRRR09",
        "camino": "CLINICA-PANTEON",
        "municipio": "ACAXOCHITLÁN",
        "localidad": "SANTA ANA TZACUALA",
        "solicitante": "GERARDO MARTÍNEZ CRUZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "TOTA840626HHGLLN02",
        "camino": "TECUEYACA-TECPACO",
        "municipio": "CALNALI",
        "localidad": "TECUEYACA",
        "solicitante": "ANCELMO TOLENTINO TOLENTINO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SAXJ580918HHGMXS00",
        "camino": "PALZOQUITEMPA-E.C. CALNALI-SANTA LUCIA",
        "municipio": "CALNALI",
        "localidad": "PALZOQUITEMPA",
        "solicitante": "JOSÉ SAMANIEGO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "VABC831204HHGLTR07",
        "camino": "RANCHO NUEVO-E.C. CALNALI-SANTA LUCIA",
        "municipio": "CALNALI",
        "localidad": "RANCHO NUEVO",
        "solicitante": "CRISANTO VALERIO BAUTISTA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HIVD731224HHGLDL03",
        "camino": "TECPACO-SAN ANDRÉS CHICHAYOTLA",
        "municipio": "CALNALI",
        "localidad": "TECPACO",
        "solicitante": "DELFINO HILARIO VIDAL",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "IUHF860307HHGTRR09",
        "camino": "TULA-E.C. CALNALI-ATLAPEXCO",
        "municipio": "CALNALI",
        "localidad": "TULA",
        "solicitante": "FRANCISCO ITURBIDE HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AETF590925HHGRRR09",
        "camino": "CALLE 16 DE MAYO-27 DE SEPTIEMBRE",
        "municipio": "HUICHAPAN",
        "localidad": "EL SAUCILLO",
        "solicitante": "FRANCISCO ARTEAGA TREJO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RERM790223HHGSMR08",
        "camino": "DEL ACCESO A LA ESCUELA",
        "municipio": "HUICHAPAN",
        "localidad": "LA ESCONDIDA",
        "solicitante": "MARCO ANTONIO RESÉNDIZ RAMÍREZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MEMR970824MHGJRC09",
        "camino": "PROLONGACIÓN 2 DE ABRIL",
        "municipio": "ACTOPAN",
        "localidad": "POZO GRANDE",
        "solicitante": "ROCIÓ GUADALUPE MEJÍA MORALES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AOBJ570521HHGJRV05",
        "camino": "HACIA TENEXPA, CALLE JAIME NUNO",
        "municipio": "HUICHAPAN",
        "localidad": "ZOTHE",
        "solicitante": "JAVIER AJOLEZA BARRAGÁN",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "UICH791210HHGRHL08",
        "camino": "HUIXCAZDHA",
        "municipio": "HUICHAPAN",
        "localidad": "HUIXCAZDHA",
        "solicitante": "HELIBERTO URIBE CHÁVEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PELO840919HHGRNS09",
        "camino": "LA ESTANCIA-SANTANA SUR",
        "municipio": "ATOTONILCO EL GRANDE",
        "localidad": "SANTANA SUR",
        "solicitante": "OSCAR ALEJANDRO PÉREZ LUNA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PIPD730525HHGMRN06",
        "camino": "ENTRONQUE CUMBRE SANTA CATARINA-SAN MARTIN",
        "municipio": "ATOTONILCO EL GRANDE",
        "localidad": "SAN MARTIN",
        "solicitante": "DANIEL PIMENTEL PÉREZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MOHF751129HSPRRL05",
        "camino": "ACCESO TOCAPA",
        "municipio": "CHAPULHUACAN",
        "localidad": "TOCAPA",
        "solicitante": "FILOGONIO MORALES HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AOGA930929MHGNTN09",
        "camino": "ACCESO GRUTA DE CARRIZAL DE TENANGO",
        "municipio": "CHAPULHUACAN",
        "localidad": "TENANGO",
        "solicitante": "ANAYELI ANTONIO GUTIÉRREZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RIOE920328HHGVRZ02",
        "camino": "ACCESO SAUCILLO AGUA NUEVA",
        "municipio": "CHAPULHUACAN",
        "localidad": "SAUCILLO AGUA NUEVA",
        "solicitante": "EZEQUIEL RIVERA ORTIZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEHV720121HHGRRC19",
        "camino": "ACCESO LAS MINAS",
        "municipio": "CHAPULHUACAN",
        "localidad": "LAS MINAS",
        "solicitante": "VICENTE HERNÁNDEZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GUCE771226HHGRHS00",
        "camino": "CAMINO HACIA LAS ESCUELAS",
        "municipio": "PISAFLORES",
        "localidad": "EL LIMONCITO",
        "solicitante": "ESTEBAN GUERRERO CHÁVEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RUGF670614HHGBRL00",
        "camino": "CALLE S/N",
        "municipio": "PISAFLORES",
        "localidad": "LA PEÑA",
        "solicitante": "JOSÉ FÉLIX RUBIO GARAY",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "JUEE850424HHGLSS01",
        "camino": "HUITZNOPALA-CRUCERO TLALTEPINGO",
        "municipio": "LOLOTLA",
        "localidad": "HUITZNOPALA",
        "solicitante": "ESTEBAN JULIÁN ESCUDERO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "NIGG900802HHGVNS02",
        "camino": "CALLE PRINCIPAL",
        "municipio": "PISAFLORES",
        "localidad": "EL AGUACATE",
        "solicitante": "GUSTAVO NIEVES GONZÁLEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MOAB630203HHGRVL00",
        "camino": "RANCHO NUEVO-LA LOMITA",
        "municipio": "PISAFLORES",
        "localidad": "RANCHO NUEVO",
        "solicitante": "BLAS MORALES ÁVILA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "EABR811228MHGSSS02",
        "camino": "CALLE DEL BARRIO EL PETATILLO",
        "municipio": "PISAFLORES",
        "localidad": "LA PEÑA",
        "solicitante": "ROSA NELVA ESTRADA BUSTAMANTE",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "FOEA790112MHGNSL02",
        "camino": "DESVIACIÓN A LA COMUNIDAD EL ZACATAL",
        "municipio": "PISAFLORES",
        "localidad": "EL ZACATAL",
        "solicitante": "ALFREDA FONSECA ESTRADA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "FOGF831119HHGLDL08",
        "camino": "CAÑADA DE FLORES-SAN DIEGO",
        "municipio": "METEPEC",
        "localidad": "CAÑADA DE FLORES",
        "solicitante": "FELICIANO FLORES GODÍNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "JEAJ741227HHGSGN09",
        "camino": "CALLE UNIÓN",
        "municipio": "TEZONTEPEC DE ALDAMA",
        "localidad": "SANTA MARÍA NATIVITAS ATENGO",
        "solicitante": "JUAN DE JESÚS AGUILAR",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "JEAJ741227HHGSGN09",
        "camino": "CALLE UNIÓN PONIENTE",
        "municipio": "TEZONTEPEC DE ALDAMA",
        "localidad": "SANTA MARÍA NATIVITAS ATENGO",
        "solicitante": "JUAN DE JESÚS AGUILAR",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "JEAJ741227HHGSGN09",
        "camino": "CALLE LA CRUZ",
        "municipio": "TEZONTEPEC DE ALDAMA",
        "localidad": "SANTA MARÍA NATIVITAS ATENGO",
        "solicitante": "JUAN DE JESÚS AGUILAR",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "JEAJ741227HHGSGN09",
        "camino": "AV. 20DE NOVIEMBRE",
        "municipio": "TEZONTEPEC DE ALDAMA",
        "localidad": "SANTA MARÍA NATIVITAS ATENGO",
        "solicitante": "JUAN DE JESÚS AGUILAR",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "JEAJ741227HHGSGN09",
        "camino": "MELCHOR OCAMPO",
        "municipio": "TEZONTEPEC DE ALDAMA",
        "localidad": "SANTA MARÍA NATIVITAS ATENGO",
        "solicitante": "JUAN DE JESÚS AGUILAR",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AAAL680630MDFYRC01",
        "camino": "ACCESO AL CENTRO DE SALUD Y PRIMARIA",
        "municipio": "EL ARENAL",
        "localidad": "OJO DE AGUA",
        "solicitante": "LUCINA AYALA ARIAS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "JEAJ741227HHGSGN09",
        "camino": "CALLE MORELOS",
        "municipio": "TEZONTEPEC DE ALDAMA",
        "localidad": "SANTA MARÍA NATIVITAS ATENGO",
        "solicitante": "JUAN DE JESÚS AGUILAR",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BAVA741004MHGRGN08",
        "camino": "MZA. LA TINAJA",
        "municipio": "TASQUILLO",
        "localidad": "SAN PEDRO",
        "solicitante": "ANA BARRERA VEGA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GUMM941003MHGZNR09",
        "camino": "EL MAMTHA-AGUA HEDEONDA",
        "municipio": "METZTITLÁN",
        "localidad": "EL MAMTHA",
        "solicitante": "MARISELA GUZMÁN MONROY",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BAGK881124MHGTNR04",
        "camino": "AV. GUERRERO",
        "municipio": "MINERAL DE LA REFORMA",
        "localidad": "AZOYATLA DE OCAMPO",
        "solicitante": "KAREN BAUTISTA GONZÁLEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "FOCT840501MHGLNL04",
        "camino": "ACCESO A LA COMUNIDAD EL DEFAY",
        "municipio": "IXMIQUILPAN",
        "localidad": "EL DEFAY",
        "solicitante": "TLAZANTLY FLORES CANTERA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "LEQJ800723HHGLNN04",
        "camino": "JAGUEY-E.C. TEPEAPULCO-CUAUTEPEC",
        "municipio": "TEPEAPULCO",
        "localidad": "PALMILLAS",
        "solicitante": "JUANA LEAL QUINTERO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RALE820619MHGMNL09",
        "camino": "ACCESO JAGUEY VIEJO",
        "municipio": "EPAZOYUCAN",
        "localidad": "JAGUEY VIEJO",
        "solicitante": "ELIZABETH RAMÍREZ LEÓN",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MEZF610627HHGNRR07",
        "camino": "CAMINO AL PANTEÓN",
        "municipio": "TEPEAPULCO",
        "localidad": "TULTENGO",
        "solicitante": "FERNANDO MENESES ZARATE",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BAMN890928HNLNRX11",
        "camino": "AV. PRINCIPAL, BARRIO EL CAPULÍN",
        "municipio": "METZTITLÁN",
        "localidad": "TLATEPEXE",
        "solicitante": "NOE GUADALUPE BANDA MORALES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CUHA801115HHGRRR08",
        "camino": "EL PUERTO TAVERA",
        "municipio": "SANTIAGO DE ANAYA",
        "localidad": "HERMOSILLO MONTE NOBLE",
        "solicitante": "ARCENIO CRUZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MUTP660311HHGXRB07",
        "camino": "ACCESO CUAUHTÉMOC",
        "municipio": "TASQUILLO",
        "localidad": "CUAUHTÉMOC",
        "solicitante": "PABLO MUÑOZ TREJO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MAFJ770901HHGRRS02",
        "camino": "HUITEPEC-AMOXCO-IXTLAPALA",
        "municipio": "TLANCHINOL",
        "localidad": "HUITEPEC",
        "solicitante": "JOSÉ MARTÍNEZ FRANCISCO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GAGA890707HHGLRN00",
        "camino": "CUAUNEPANTLA-TECHOCHALCO (LAS MINAS)",
        "municipio": "ACAXOCHITLÁN",
        "localidad": "CUAUNEPANTLA",
        "solicitante": "JOSÉ ANDRÉS GALINDO GARCÍA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "VAMA021031HHGRRLA9",
        "camino": "SAN FERNANDO-SANTA CATARINA",
        "municipio": "ACAXOCHITLÁN",
        "localidad": "SAN FERNANDO",
        "solicitante": "ALEXIS RICARDO VARGAS MARTÍNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEFG050104HHGRLVA3",
        "camino": "ANTONIO GONZÁLEZ",
        "municipio": "ACAXOCHITLÁN",
        "localidad": "EJIDO TEPEPA",
        "solicitante": "GEOVANNI ARTEMIO HERNÁNDEZ FLORENCIA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AUOJ040817HHGGLSA3",
        "camino": "SANTA CRUZ-SAN BARTOLO TUTOTEPEC",
        "municipio": "SAN BARTOLO TUTOTEPEC",
        "localidad": "SANTA CRUZ",
        "solicitante": "JESÚS AGUILAR OLVERA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "ZACO941016HHGRRS01",
        "camino": "SANTO DOMINGO",
        "municipio": "HUAUTLA",
        "localidad": "HUAUTLA",
        "solicitante": "OSWALDO ANDRÉS ZARAGOZA DE LA CRUZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "DIVG721011HHGZLM02",
        "camino": "ACCESO BARRIO LA CRUZ",
        "municipio": "ATOTONILCO EL GRANDE",
        "localidad": "BARRIO LA CRUZ",
        "solicitante": "GUMARO DIAZ VALENCIA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GAHM691202MVZRRN00",
        "camino": "AV. MISTERIO",
        "municipio": "IXMIQUILPAN",
        "localidad": "COL. GRAL. FELIPE ÁNGELES",
        "solicitante": "MINERVA GARCÍA HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "TEMC031119HHGLNRA5",
        "camino": "CIENEGUILLAS-APIPILHUASCO",
        "municipio": "ATOTONILCO EL GRANDE",
        "localidad": "COL.  CENTRO",
        "solicitante": "CARLOS FRANCISCO TÉLLEZ MONTIEL",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AAMA630827HHGMRR07",
        "camino": "TANCHA",
        "municipio": "HUEJUTLA DE REYES",
        "localidad": "COACUILCO",
        "solicitante": "ARMANDO AMADOR MARTÍNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PEVG740930HHGRLR04",
        "camino": "CONSTRUCCIÓN DE PUENTE",
        "municipio": "HUICHAPAN",
        "localidad": "DANTZIBOJAY",
        "solicitante": "GERÓNIMO PÉREZ VILLEDA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CECE570503HHGRRV02",
        "camino": "PEPEYOCA DE CABRERA-CHALACUACO",
        "municipio": "HUAUTLA",
        "localidad": "PEPEYOCA DE CABRERA",
        "solicitante": "EVENCIO CRESPO CRUZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MOSH810707HDFRTG00",
        "camino": "TLAMIMILOLPA-LA MESA-COYAMETEPEC",
        "municipio": "ACAXOCHITLÁN",
        "localidad": "TLAMIMILOLPA",
        "solicitante": "HUGO ENRIQUE MORALES SOTO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "LOGR751024MHGPMF06",
        "camino": "LA LOMA EN SAN JOSÉ PIEDRA GORDA",
        "municipio": "TEPEJI DEL RIO",
        "localidad": "SAN JOSÉ PIEDRA GORDA",
        "solicitante": "RAFAELA LÓPEZ GÓMEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RAEN851201MHGMST00",
        "camino": "EXHACIENDA EL GALÁN",
        "municipio": "EPAZOYUCAN",
        "localidad": "EL GUAJOLOTE",
        "solicitante": "NATALIA RAMOS ESCOBAR",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AARL990619MHGMSL07",
        "camino": "EL GUAJOLOTE-EL GALÁN",
        "municipio": "EPAZOYUCAN",
        "localidad": "EL GALÁN",
        "solicitante": "LILIANA AMADOR DE LA ROSA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "LUSR730704HHGGLY01",
        "camino": "CALLE NIÑOS HÉROES",
        "municipio": "EL ARENAL",
        "localidad": "EL MEJE",
        "solicitante": "RAYMUNDO LUGO SALAZAR",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GOMV921118HHGDRC04",
        "camino": "AV. DEL ROSARIO",
        "municipio": "ALFAJAYUCAN",
        "localidad": "DOZDHA",
        "solicitante": "VÍCTOR GODÍNEZ MARTÍNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEMA560709HHGRNN06",
        "camino": "SAN MIGUEL ALLENDE",
        "municipio": "TEPEAPULCO",
        "localidad": "SAN MIGUEL ALLENDE",
        "solicitante": "ANATOLIO HERNÁNDEZ MENESES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CXCA671210MHGZZN01",
        "camino": "CALLE SAUCE, COL. SANTA RITA",
        "municipio": "CUAUTEPEC DE HINOJOSA",
        "localidad": "CUAUTEPEC DE HINOJOSA",
        "solicitante": "MARÍA ANGELICA CAZARES CAZARES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "DIRL770304MHGZYC02",
        "camino": "ACCESO ACAPA",
        "municipio": "TLAHUILTEPA",
        "localidad": "ACAPA",
        "solicitante": "LUCIA DIAZ REYES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PEGA620711HHGLRN05",
        "camino": "LIBRAMIENTO LÁZARO CÁRDENAS",
        "municipio": "TLAHUILTEPA",
        "localidad": "LÁZARO CÁRDENAS",
        "solicitante": "ANTOLÍN PELCASTRE GUERRERO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "TERF770424HHGRND08",
        "camino": "HIGUERÓN-PISAFLORES",
        "municipio": "PISAFLORES",
        "localidad": "EL HIGUERÓN",
        "solicitante": "FIDEL TREJO RANGEL",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "DOLA800101HMCMRL06",
        "camino": "CALLE GUADALUPE Y PERIFERIA",
        "municipio": "TIZAYUCA",
        "localidad": "TEPOJACO",
        "solicitante": "ALBERTO DOMÍNGUEZ LARA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SAMK001010MHGNRRA2",
        "camino": "LLANO GRANDE-RANCHO JARILLO",
        "municipio": "HUASCA DE OCAMPO",
        "localidad": "LLANO GRANDE",
        "solicitante": "KAREN JOSSELIN SÁNCHEZ MARTÍNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MAGE790407HHGRRR09",
        "camino": "NEXPA-CHACUALA",
        "municipio": "SAN FELIPE ORIZATLÁN",
        "localidad": "NEXPA",
        "solicitante": "ERNESTO MARTÍNEZ GARCÍA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "TOHP590802HHGLRD03",
        "camino": "TZAPOLLO I-TZAPOLLO II",
        "municipio": "SAN FELIPE ORIZATLÁN",
        "localidad": "TZAPOLLO I",
        "solicitante": "PEDRO TOLENTINO HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AAOE020722HHGMLRA0",
        "camino": "LOS BORDOS",
        "municipio": "OMITLÁN DE JUÁREZ",
        "localidad": "SAN ANTONIO EL POZO",
        "solicitante": "ERICK AMADOR OLVERA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "FEFY811117MHGRRN20",
        "camino": "CBTIS 287-AV. LAS TORRES",
        "municipio": "SANTIAGO TULANTEPEC",
        "localidad": "SAN ISIDRO",
        "solicitante": "MA. YANET FERNÁNDEZ FERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "IAH800916HHGSLR08",
        "camino": "TORTUGAS-HUASCA",
        "municipio": "METEPEC",
        "localidad": "ZACATEPEC",
        "solicitante": "HERNÁN ROGELIO ISLAS SOLÍS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "EIVA711101HHGLLL04",
        "camino": "LOS REYES-AGUA ZARCA",
        "municipio": "HUASCA DE OCAMPO",
        "localidad": "LOS REYES TEPEZALÁ",
        "solicitante": "ALFONSO ELIZALDE VILLEGAS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "FEFY811117MHGRRN20",
        "camino": "CALLE REVOLUCIÓN",
        "municipio": "SANTIAGO TULANTEPEC",
        "localidad": "SAN ISIDRO",
        "solicitante": "MA. YANET FERNÁNDEZ FERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BAGA850815MHGDRS01",
        "camino": "CALLE BELISARIO DOMÍNGUEZ-SANTO TOMAS DE ALLENDE",
        "municipio": "HUASCA DE OCAMPO",
        "localidad": "SANTO TOMAS DE ALLENDE",
        "solicitante": "ASUCENA BADILLO GARCÍA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GOQM810927HHGDJG08",
        "camino": "SANTUARIO-LAS TIENDITAS",
        "municipio": "CARDONAL",
        "localidad": "SANTUARIO",
        "solicitante": "MIGUEL GODÍNEZ QUIJANO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "VIRA810317MHGXYD09",
        "camino": "S/N",
        "municipio": "NICOLÁS FLORES",
        "localidad": "CERRO DE LA CRUZ",
        "solicitante": "AIDÉE VIXTHA REYO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "DUAG940826MHGRND07",
        "camino": "ACCESO BARRIO MORELOS",
        "municipio": "ELOXOCHITLÁN",
        "localidad": "HUALULA",
        "solicitante": "MA. GUADALUPE DURAN ÁNGELES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "ROMC660301HHGSJR09",
        "camino": "LA CAMPANA DE TUTOTEPEC-MEDIO MONTE",
        "municipio": "SAN BARTOLO TUTOTEPEC",
        "localidad": "TUTOTEPEC",
        "solicitante": "CARLOS ROSALES MEJÍA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "LUTG670325MHGGRL06",
        "camino": "HACIA EL EJIDO",
        "municipio": "CHAPANTONGO",
        "localidad": "DEXHA",
        "solicitante": "GLORIA LUGO TORRES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "DOMJ630118HDFMTN10",
        "camino": "OLIVOS-TABACHINES-FRESNOS",
        "municipio": "TIZAYUCA",
        "localidad": "EL MIO CID",
        "solicitante": "JUAN JAVIER DOMÍNGUEZ MATA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AIRS571015HHGVVR00",
        "camino": "PRINCIPAL A LA COMUNIDAD",
        "municipio": "TEPEAPULCO",
        "localidad": "SUBESTACIÓN OCHO DE PEMEX",
        "solicitante": "SERGIO ÁVILA RIVERO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "OEGF690402HHGLRR06",
        "camino": "NUEVA SANTA LUCIA",
        "municipio": "CHAPANTONGO",
        "localidad": "NUEVA SANTA LUCIA",
        "solicitante": "FRANCISCO OLVERA GARCÍA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CUVN600318HHGRRR04",
        "camino": "PUERTA BLANCA-ALTA CALIFORNIA",
        "municipio": "CHAPANTONGO",
        "localidad": "SANTA MARÍA AMEALCO",
        "solicitante": "NARCIZO CRUZ VARGAS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RITA861216MHGVRN00",
        "camino": "COMALTITLÁN",
        "municipio": "JACALA DE LEDEZMA",
        "localidad": "COMALTITLÁN",
        "solicitante": "ANA RIVERA TREJO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "TAAM730304HHGDNR02",
        "camino": "CDA. TAJO, CDA. MEZA, CDA. MEZA 1CDA. LUIS DONALDO COLOSIO",
        "municipio": "TULA DE ALLENDE",
        "localidad": "SAN LORENZO",
        "solicitante": "MARCO ANTONIO TADEO ÁNGELES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEOB020901MHGRRRA0",
        "camino": "TEPETATES-LA CAÑADA",
        "municipio": "TEPEAPULCO",
        "localidad": "LA CAÑADA",
        "solicitante": "BERENICE HERNÁNDEZ ORTEGA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "FURE800115HHGNMD04",
        "camino": "LIBRAMIENTO DE LA COM. CANDELARIA",
        "municipio": "TASQUILLO",
        "localidad": "CANDELARIA",
        "solicitante": "EDI JOSÉ FUENTES RAMÍREZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "JIPC500717HDFMRR03",
        "camino": "AV. PARTIDAS",
        "municipio": "TIZAYUCA",
        "localidad": "OLMOS",
        "solicitante": "CARMELO ALEJO JIMÉNEZ PORRAS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CARC600714HHGHSR03",
        "camino": "UXDEJHE",
        "municipio": "TECOZAUTLA",
        "localidad": "UXDEJHE",
        "solicitante": "CIRO CHÁVEZ RESÉNDIZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GARO810827HHGRDS03",
        "camino": "EL CARGADERO-LA ESCONDIDA DE LO VERDE",
        "municipio": "PISAFLORES",
        "localidad": "LA ESCONDIDA DE LO VERDE",
        "solicitante": "OSCAR GARNICA RODRÍGUEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AUMV900427HHGGNS08",
        "camino": "CALLE PRINCIPAL DEL CENTRO-EL BORDO",
        "municipio": "TULA DE ALLENDE",
        "localidad": "XIJAY DE CUAUHTÉMOC",
        "solicitante": "VISAEL AGUILAR MONROY",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "DIDJ820220HHGMMQ07",
        "camino": "AV. LOS PINOS",
        "municipio": "TECOZAUTLA",
        "localidad": "LA MESILLA",
        "solicitante": "JOAQUÍN DIMAS DIMAS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MOAD840604MGRNMN00",
        "camino": "LA VENTA-LA RINCONADA",
        "municipio": "EPAZOYUCAN",
        "localidad": "EL GUAJOLOTE",
        "solicitante": "DIANA BERENICE MONTIEL AMADOR",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "ZERR611230HDFPBB01",
        "camino": "LOS MOROS",
        "municipio": "TECOZAUTLA",
        "localidad": "LOS MOROS",
        "solicitante": "RUBÉN ZEPEDA RUBIO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEMT710305HHGRGM04",
        "camino": "ACCESO PRINCIPAL A CHIAPA",
        "municipio": "XOCHIATIPAN",
        "localidad": "CHIAPA",
        "solicitante": "TOMAS HERNÁNDEZ MAGDALENA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BAHO721120HHGTRC17",
        "camino": "SANTIAGO SEGUNDO-XOCHIATIPAN",
        "municipio": "XOCHIATIPAN",
        "localidad": "SANTIAGO SEGUNDO",
        "solicitante": "OCTAVIO BAUTISTA HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GAPA671121HHGMLL01",
        "camino": "CDA. LOS LIRIOS",
        "municipio": "MINERAL DEL CHICO",
        "localidad": "CARBONERAS",
        "solicitante": "ALBERTO GAMERO PALAFOX",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "LOLM450717HHGPZR01",
        "camino": "CALLE FRANCISCO VILLA",
        "municipio": "TULA DE ALLENDE",
        "localidad": "BOMINTZHA",
        "solicitante": "MARCELINO LÓPEZ DE LA LUZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "TECR751206MHGDRF06",
        "camino": "AV. INSURGENTES",
        "municipio": "TULA DE ALLENDE",
        "localidad": "XITEJE DE LA REFORMA",
        "solicitante": "MARÍA DEL REFUGIO TEODOSIO CRUZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "LOHT871014MHGPRR07",
        "camino": "5 DE MAYO",
        "municipio": "ACTOPAN",
        "localidad": "LA LOMA",
        "solicitante": "TERESA LÓPEZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "NAHF910227HHGRRS03",
        "camino": "TEPEXICUICUIL-PETACOTITA",
        "municipio": "JALTOCÁN",
        "localidad": "TEPEXICUICUIL",
        "solicitante": "FAUSTINO MARTÍNEZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SAHR651227HHGNRF07",
        "camino": "ACCESO BARRIO LA CRUZ",
        "municipio": "EPAZOYUCAN",
        "localidad": "SANTA MÓNICA",
        "solicitante": "J. REFUGIO SÁNCHEZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CORM610610HHGHJR02",
        "camino": "ACCESO AL PANTEÓN Y LA MESA",
        "municipio": "PACULA",
        "localidad": "PUERTO GRANDE",
        "solicitante": "MARGARITO CHORA ROJO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MOHM710318MQTNRN00",
        "camino": "FRANCISCO JIMÉNEZ",
        "municipio": "TIZAYUCA",
        "localidad": "CHABACANOS",
        "solicitante": "MINERVA MONDRAGÓN HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GAZP670410MDFRMT02",
        "camino": "PORFIRIO JIMÉNEZ",
        "municipio": "TIZAYUCA",
        "localidad": "TIZAYUCA",
        "solicitante": "PATRICIA GARCÍA ZAMORA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "DOCI830705HHGMRS06",
        "camino": "CALLE EL PEDREGAL",
        "municipio": "TULA DE ALLENDE",
        "localidad": "SAN LUCAS TEACALCO",
        "solicitante": "ISRAEL DOMÍNGUEZ CERÓN",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "COGG940928HHGRRS04",
        "camino": "CALLE PRINCIPAL",
        "municipio": "SAN SALVADOR",
        "localidad": "EL FRESNO",
        "solicitante": "GUSTAVO CORONA GARNICA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "JIGG860531HHGMRD00",
        "camino": "TIZAPÁN-TLAHUELOMPA",
        "municipio": "ZACUALTIPÁN DE ÁNGELES",
        "localidad": "TIZAPÁN",
        "solicitante": "JOSÉ GUADALUPE JIMÉNEZ GARCÍA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "DUVG821107HHGRZD09",
        "camino": "DE LA IGLESIA Y AL PANTEÓN",
        "municipio": "ACATLÁN",
        "localidad": "EL YOLO",
        "solicitante": "GUADALUPE DURAN VÁZQUEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AIAS571109HHGVNL08",
        "camino": "DOS CAMINOS-TECOMATE",
        "municipio": "ELOXOCHITLÁN",
        "localidad": "TECOMATE",
        "solicitante": "SALVADOR ÁVILA ÁNGELES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "ZUER690221HHGXSB09",
        "camino": "REFORMA",
        "municipio": "MIXQUIAHUALA DE JUÁREZ",
        "localidad": "JAGUEY BLANCO",
        "solicitante": "ROBERTO ZÚÑIGA ESCAMILLA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CAHA751020HHGHRB06",
        "camino": "ACCESO A MZA. CORRALES",
        "municipio": "PACULA",
        "localidad": "SANTA MARÍA MIRAFLORES",
        "solicitante": "ABEL CHÁVEZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RASO790822HHGMNM07",
        "camino": "CANDHO",
        "municipio": "TASQUILLO",
        "localidad": "SAN ISIDRO",
        "solicitante": "OMAR RAMÍREZ SANJUAN",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "TEMJ941216HHGRRN07",
        "camino": "TINTHE-SABINA",
        "municipio": "ZIMAPÁN",
        "localidad": "TINTHE",
        "solicitante": "JONNY TREJO MARTÍNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PELF851124HDRPR02",
        "camino": "AV. CONSTITUYENTES",
        "municipio": "SANTIAGO DE ANAYA",
        "localidad": "RANCHO NUEVO",
        "solicitante": "JOSÉ FRANCISCO PÉREZ LÓPEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SIMJ810707HDFLRN15",
        "camino": "SANTA CATARINA-LOS REYES",
        "municipio": "ATOTONILCO EL GRANDE",
        "localidad": "SANTA CATARINA",
        "solicitante": "JUAN CARLOS SILVA MORENO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "LOMC870403HHGPRR04",
        "camino": "SAN MARTIN",
        "municipio": "AGUA BLANCA DE ITURBIDE",
        "localidad": "SAN MARTIN",
        "solicitante": "CARLOS LÓPEZ MARTÍNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MOSA740510MMCRNM00",
        "camino": "EL ASERRADERO",
        "municipio": "MINERAL DEL MONTE",
        "localidad": "CIÉNEGA LARGA",
        "solicitante": "AMALIA MORALES SANDOVAL",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HERH610608HHGRSR07",
        "camino": "PRINCIPAL PALO HUECO",
        "municipio": "TEPEAPULCO",
        "localidad": "PALO HUECO",
        "solicitante": "HERACLIO HERNÁNDEZ RÍOS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "FAMV690728HHGRDC09",
        "camino": "A LOS DEPÓSITOS DE AGUA",
        "municipio": "ZIMAPÁN",
        "localidad": "DURANGO",
        "solicitante": "VÍCTOR FRANCO MEDINA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AOMG940603HHGLRB01",
        "camino": "AV. PRINCIPAL",
        "municipio": "TEPEJI DEL RIO",
        "localidad": "EL MONTECILLO",
        "solicitante": "GABINO ALONSO MARTÍNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SAAM721017HHGNNR07",
        "camino": "ACCESO A COLONIAS DE SAN JOSÉ PIEDRA GORDA",
        "municipio": "TEPEJI DEL RIO",
        "localidad": "SAN JOSÉ PIEDRA GORDA",
        "solicitante": "MARGARITO SANTILLÁN ÁNGELES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CAJS740421MHGMML18",
        "camino": "LA 25",
        "municipio": "SAN SALVADOR",
        "localidad": "SANTA MARÍA AMAJAC",
        "solicitante": "SILVIA CAMARGO JIMÉNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HUGC981124MHGRRR05",
        "camino": "HACIA ESC. BENITO JUÁREZ Y PREESCOLAR",
        "municipio": "TEPEJI DEL RIO",
        "localidad": "EL BANCO",
        "solicitante": "CRISTINA HURTADO GARCÍA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MESL810209HHGJLN00",
        "camino": "CALLE EMILIANO ZAPATA",
        "municipio": "SANTIAGO DE ANAYA",
        "localidad": "CERRITOS",
        "solicitante": "LINO MEJÍA SALAS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SACJ930603HHGNHL06",
        "camino": "PANALES-EL DECA",
        "municipio": "IXMIQUILPAN",
        "localidad": "PANALES",
        "solicitante": "JULIO CESAR SÁNCHEZ CHÁVEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "TERF660605HHGRMS00",
        "camino": "ESCUELA-LA MANZANA LA JOYA",
        "municipio": "ZIMAPÁN",
        "localidad": "XINDHO SEGUNDO",
        "solicitante": "FAUSTINO TREJO RAMÍREZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEHJ801217HVZRRS05",
        "camino": "CALLE LIMA",
        "municipio": "ZAPOTLÁN DE JUÁREZ",
        "localidad": "ACAYUCA",
        "solicitante": "JESÚS HERNÁNDEZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PAVL981209MHGLLR06",
        "camino": "HACIA EL CAMPO DE FUTBOL",
        "municipio": "MINERAL DEL MONTE",
        "localidad": "SANTA ROSALÍA",
        "solicitante": "LORENA PALACIOS VALENCIA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MOMD771130MHGRRL04",
        "camino": "AV. OLIMPIA",
        "municipio": "ZAPOTLÁN DE JUÁREZ",
        "localidad": "ACAYUCA",
        "solicitante": "DALILA MORALES MORENO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CUZL811027MHGRXL06",
        "camino": "CALLE S/N-AV. JUÁREZ",
        "municipio": "EL ARENAL",
        "localidad": "FRUTILLAL BAJO",
        "solicitante": "LILIANA CRUZ ZÚÑIGA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "LOGH680325HHGPRM01",
        "camino": "LA GARRITA",
        "municipio": "EL ARENAL",
        "localidad": "SAN JOSÉ TEPENENE",
        "solicitante": "HUMBERTO LÓPEZ GARCÍA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AEDA721109HHGNMR08",
        "camino": "CARRIZAL-POLONIA",
        "municipio": "EL ARENAL",
        "localidad": "EL RINCÓN",
        "solicitante": "ARTURO ÁNGELES DAMAS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MOGV631001HDFRNC04",
        "camino": "EMILIANO ZAPATA",
        "municipio": "EL ARENAL",
        "localidad": "SANTA ROSA",
        "solicitante": "VÍCTOR OCTAVIO MORA GONZÁLEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GOEM970502MHGMSR02",
        "camino": "CALLE FRANCISCO I. MADERO",
        "municipio": "AJACUBA",
        "localidad": "AJACUBA",
        "solicitante": "MARISOL GÓMEZ ESLAVA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEBE881017HHGRDD07",
        "camino": "CRUZ AZUL",
        "municipio": "ACAXOCHITLÁN",
        "localidad": "TLAMIMILOLPA",
        "solicitante": "EDUARDO HERNÁNDEZ BADILLO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MOAG910905MHGRND04",
        "camino": "HIDALGO",
        "municipio": "SAN AGUSTÍN TLAXIACA",
        "localidad": "MONTE DE GUADALUPE",
        "solicitante": "MARÍA GUADALUPE MORALES ÁNGELES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AEMY030610MMCRNSA9",
        "camino": "AGUA FRÍA-SAN PEDRO XUEXOTITLA",
        "municipio": "OMITLÁN DE JUÁREZ",
        "localidad": "AGUA FRÍA",
        "solicitante": "YOSELYNE ARMENTA MONTES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "VANS730811MHGRVS01",
        "camino": "CALLE MORELOS",
        "municipio": "EPAZOYUCAN",
        "localidad": "SAN JUAN TIZAHUAPAN",
        "solicitante": "MA SUSANA VARGAS NUVE",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BAMA020212HMCLRRA1",
        "camino": "ACCESO SAN NICOLÁS COATZONTLA",
        "municipio": "JUÁREZ HIDALGO",
        "localidad": "SAN NICOLÁS COATZONTLA",
        "solicitante": "JOSÉ ARMANDO BALTAZAR MORENO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MIAG791106MDFMCD02",
        "camino": "CALLE PRINCIPAL DE EL SALTO",
        "municipio": "EPAZOYUCAN",
        "localidad": "EL SALTO",
        "solicitante": "MARÍA GUADALUPE MIMILA ACOSTA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BACL920111HHGTRN01",
        "camino": "AV. QUETZALCÓATL",
        "municipio": "AJACUBA",
        "localidad": "SANTIAGO TEZONTLALE",
        "solicitante": "LENIN JAVIER BAUTISTA CERÓN",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BACL920111HHGTRN01",
        "camino": "CALLE EMILIANO ZAPATA-CALLE IGNACIO ALLENDE",
        "municipio": "AJACUBA",
        "localidad": "SANTIAGO TEZONTLALE",
        "solicitante": "LENIN JAVIER BAUTISTA CERÓN",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEGJ980822HHGRLV08",
        "camino": "ACCESO A SANTA MARÍA",
        "municipio": "JUÁREZ HIDALGO",
        "localidad": "SANTA MARÍA MACUHILXOCHITL",
        "solicitante": "JAVIER HERNÁNDEZ GIL",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SAHB760520MHGNRR08",
        "camino": "AV. PRESAS",
        "municipio": "TEZONTEPEC DE ALDAMA",
        "localidad": "LÁZARO CÁRDENAS",
        "solicitante": "BERNARDA SÁNCHEZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MEMM610319MHGJNN06",
        "camino": "CALLE AYUTLA",
        "municipio": "TEZONTEPEC DE ALDAMA",
        "localidad": "MANGAS",
        "solicitante": "MINERVA MEJÍA MONTES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BACL920111HHGTRN01",
        "camino": "CALLE TENOCHTITLAN-TEOTIHUACAN-ZACOTZIN",
        "municipio": "AJACUBA",
        "localidad": "SANTIAGO TEZONTLALE",
        "solicitante": "LENIN JAVIER BAUTISTA CERÓN",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PIHB930213MHGNRT07",
        "camino": "AV. ÁLVARO OBREGÓN",
        "municipio": "AJACUBA",
        "localidad": "SAN NICOLÁS TECOMATLÁN",
        "solicitante": "BEATRIZ PINEDA HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PIHB930213MHGNRT07",
        "camino": "AV. VERACRUZ",
        "municipio": "AJACUBA",
        "localidad": "SAN NICOLÁS TECOMATLÁN",
        "solicitante": "BEATRIZ PINEDA HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PIHB930213MHGNRT07",
        "camino": "AV. HIDALGO",
        "municipio": "AJACUBA",
        "localidad": "SAN NICOLÁS TECOMATLÁN",
        "solicitante": "BEATRIZ PINEDA HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PESL810809HHGRRS01",
        "camino": "ACCESO MECAPALA",
        "municipio": "XOCHICOATLAN",
        "localidad": "MECAPALA",
        "solicitante": "JOSÉ LUIS PÉREZ SIERRA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RAIG020123HHGMSBA4",
        "camino": "PRINCIPAL TLAHUILTEPA",
        "municipio": "TIANGUISTENGO",
        "localidad": "TLAHUILTEPA",
        "solicitante": "GABRIEL RAMOS ISIDRO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "VERR580323HHGRBB06",
        "camino": "PRINCIPAL TEXACAL",
        "municipio": "TIANGUISTENGO",
        "localidad": "TEXACAL",
        "solicitante": "ROBERTO VERGARA RUBIO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MABA900421HHGRTL05",
        "camino": "POLINTOTLA",
        "municipio": "TIANGUISTENGO",
        "localidad": "POLINTOTLA",
        "solicitante": "ALEJANDRO MARIANO BAUTISTA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEHD650612MHGRRR09",
        "camino": "CHAPULTEPEC DE POZOS-LA MESA",
        "municipio": "SAN AGUSTÍN TLAXIACA",
        "localidad": "CHAPULTEPEC DE POZOS",
        "solicitante": "DORA MARÍA HERNÁNDEZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MEPY830928MDFJRN00",
        "camino": "REAL EL SENTHE",
        "municipio": "ACTOPAN",
        "localidad": "EL SENTHE",
        "solicitante": "YANIRA MEJÍA PÉREZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PEPL921218HHGDRS00",
        "camino": "AV. EL COYOTE",
        "municipio": "IXMIQUILPAN",
        "localidad": "CAÑADA CHICA",
        "solicitante": "LUIS FERNANDO PEDRAZA PÉREZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEMDD500930HHGRRM01",
        "camino": "LIM. VERACRUZ-HUITZOTLACO-LA LOMA",
        "municipio": "HUAUTLA",
        "localidad": "HUITZOTLACO",
        "solicitante": "DOMINGO HERNÁNDEZ MARTÍNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MOGC930818MHGCRT13",
        "camino": "FRANCISCO VILLA, 1° DE MAYO",
        "municipio": "FRANCISCO I. MADERO",
        "localidad": "EL ROSARIO",
        "solicitante": "CITLALLY BERENICE MOCTEZUMA GARCÍA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MEOS640120HHGZRB08",
        "camino": "AV. ÁMBAR",
        "municipio": "IXMIQUILPAN",
        "localidad": "TAXADHO",
        "solicitante": "SEBASTIÁN MEZQUITE ORTIZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CAAA010116MHGSMDA3",
        "camino": "DIGCO-LA JOYA",
        "municipio": "SINGUILUCAN",
        "localidad": "LA JOYA",
        "solicitante": "ADRIANA CASTELÁN AMADOR",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AACG710410MHGMSL03",
        "camino": "LA JOYA",
        "municipio": "SINGUILUCAN",
        "localidad": "LA JOYA",
        "solicitante": "GLORIA AMADOR CASTELÁN",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MEPP730109HHGJRD04",
        "camino": "EL ESPÍRITU-EL OLIVO",
        "municipio": "IXMIQUILPAN",
        "localidad": "EL ESPÍRITU",
        "solicitante": "PEDRO MEJAY PÉREZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "TEAS851218MHGRVS08",
        "camino": "JARDÍN DE NIÑOS-RANCHO EL COLORADO",
        "municipio": "SANTIAGO TULANTEPEC",
        "localidad": "LOS ROMEROS",
        "solicitante": "SUSANA TERRAZAS ÁVILA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEES650218HHGRTM07",
        "camino": "TIANGUIS-CUAMAPIL",
        "municipio": "TLANCHINOL",
        "localidad": "TIANGUIS",
        "solicitante": "SIMEÓN HERNÁNDEZ CUTIQUIN",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BAJH890606HHGTRM05",
        "camino": "COAMAPIL",
        "municipio": "TLANCHINOL",
        "localidad": "COAMAPIL",
        "solicitante": "HOMERO BAUTISTA JUÁREZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AEJG930904HHGNMN05",
        "camino": "ACCESO OLONTECO",
        "municipio": "ZACUALTIPÁN DE ÁNGELES",
        "localidad": "OLONTECO",
        "solicitante": "GENARO ÁNGELES JIMÉNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEPJ600311HHGRCN09",
        "camino": "AHUATEMPA-CANDELARIA",
        "municipio": "HUEJUTLA DE REYES",
        "localidad": "AHUATEMPA",
        "solicitante": "JUAN HERNÁNDEZ PACHECO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PECE570329HHGRBP04",
        "camino": "BELISARIO DOMÍNGUEZ-BARRIO SAN MIGUEL",
        "municipio": "ATOTONILCO EL GRANDE",
        "localidad": "BARRIO SAN MIGUEL",
        "solicitante": "EPIFANIO PÉREZ CABRERA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HECE841201MHGRLL09",
        "camino": "CERRO BLANCO",
        "municipio": "ATOTONILCO EL GRANDE",
        "localidad": "CERRO BLANCO",
        "solicitante": "ELIGIA HERNÁNDEZ CALVA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GUPT870323HHGRLR07",
        "camino": "TEZAHUAPA",
        "municipio": "ATOTONILCO EL GRANDE",
        "localidad": "TEZAHUAPA",
        "solicitante": "TORIBIO GUERRERO PALAFOX",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "LIMS760917MHGCNF03",
        "camino": "CUMBRE DE TEZAHUAPA-MOÑO COLORADA",
        "municipio": "ATOTONILCO EL GRANDE",
        "localidad": "TEZAHUAPA",
        "solicitante": "SOFIA LICONA MONTIEL",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MEAA940204HHGJCR02",
        "camino": "LA ESTANCIA",
        "municipio": "ATOTONILCO EL GRANDE",
        "localidad": "LA ESTANCIA",
        "solicitante": "ARNOLD MICHAEL MEJÍA ACOSTA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "TELS820908HHGLPR08",
        "camino": "APIPILHUASCO",
        "municipio": "ATOTONILCO EL GRANDE",
        "localidad": "APIPILHUASCO",
        "solicitante": "SERGIO TÉLLEZ LÓPEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GOJA911002MHGMMN06",
        "camino": "CALLE PIEDRA DE RIO",
        "municipio": "ZAPOTLÁN DE JUÁREZ",
        "localidad": "ACAYUCA",
        "solicitante": "MARÍA DE LOS ÁNGELES GÓMEZ JIMÉNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "JICC840529MDFMSR03",
        "camino": "CALLE 1938",
        "municipio": "ZAPOTLÁN DE JUÁREZ",
        "localidad": "ACAYUCA",
        "solicitante": "MARÍA DEL CARMEN JIMÉNEZ CASTILLO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CURA970328HHGRMN09",
        "camino": "PROLONGACIÓN PIRULES",
        "municipio": "ACTOPAN",
        "localidad": "HUAXTHO",
        "solicitante": "ANTONIO DE JESÚS CRUZ ROMERO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SEFL720729HHGGLZ00",
        "camino": "NAXTHEY SAN JUANICO-DEXTHI SAN JUANICO",
        "municipio": "IXMIQUILPAN",
        "localidad": "NAXTHEY SAN JUANICO",
        "solicitante": "LÁZARO SEGUNDO FELIPE",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CACS941015HSPHVR00",
        "camino": "LA LOMA-PALOSEMITA",
        "municipio": "CHAPULHUACAN",
        "localidad": "LA LOMA",
        "solicitante": "SERGIO MIGUEL CHÁVEZ COVARRUBIAS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "VITD801129HDFLRV07",
        "camino": "PRINCIPAL EL GOSCO",
        "municipio": "TENANGO DE DORIA",
        "localidad": "EL GOSCO",
        "solicitante": "DAVID FRANCISCO VILLANUEVA TORRES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "EACC770603MHGSRT06",
        "camino": "EMILIO CARRANZA \"EL DREN\" LADO SUR",
        "municipio": "FRANCISCO I. MADERO",
        "localidad": "TEPATEPEC",
        "solicitante": "CITLALLI ESCAMILLA CURIEL",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "TORA630829HHGRLD01",
        "camino": "APAPAXTLA EL GRANDE-EJIDO SANTA FÉLIX",
        "municipio": "ACAXOCHITLÁN",
        "localidad": "APAPAXTLA EL GRANDE",
        "solicitante": "ADOLFO TORRES ROLDAN",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "OAPF670129HHGRRR05",
        "camino": "CIRCUITO CAMPAÑA-CEBADAS",
        "municipio": "MINERAL DEL CHICO",
        "localidad": "CEBADAS",
        "solicitante": "FRANCISCO ORTA PÉREZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RAOM811111HHGMLR00",
        "camino": "TECOMATE-LA HACIENDA",
        "municipio": "ELOXOCHITLÁN",
        "localidad": "ITZTACAPA",
        "solicitante": "MARTIN RAMÍREZ OLIVER",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BAOM640913HHGRRR03",
        "camino": "DOS CAMINOS-TECOMATE",
        "municipio": "ELOXOCHITLÁN",
        "localidad": "CHALMITA",
        "solicitante": "MAURILIO BARRERA ORTEGA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GAGI900503HHGCMS02",
        "camino": "EL PORVENIR-LA FLORIDA",
        "municipio": "SANTIAGO DE ANAYA",
        "localidad": "EL PORVENIR",
        "solicitante": "ISMAEL GACHUZ GÓMEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GARH650504HHGCMR06",
        "camino": "LOMAS DE GUILLEN",
        "municipio": "SANTIAGO DE ANAYA",
        "localidad": "LOMAS DE GUILLEN",
        "solicitante": "HERON GACHUZ RAMÍREZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PEPZ830322HHGRRC07",
        "camino": "PUERTO TAVERA-EL ÁGUILA",
        "municipio": "SANTIAGO DE ANAYA",
        "localidad": "EL ÁGUILA",
        "solicitante": "ZACARIAS PÉREZ PÉREZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEEM641224HHGRSN00",
        "camino": "LAS PIEDRAS",
        "municipio": "SAN FELIPE ORIZATLÁN",
        "localidad": "LAS PIEDRAS",
        "solicitante": "MANUEL HERNÁNDEZ ESPINOSA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEEP480409HHGRSR06",
        "camino": "ZAPOTAL-TSITSIMI",
        "municipio": "SAN FELIPE ORIZATLÁN",
        "localidad": "ZAPOTAL",
        "solicitante": "PRÓCORO HERNÁNDEZ ESPINOZA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "DIRI810905HHGZSV00",
        "camino": "CALLE DEL CARMEN",
        "municipio": "PACHUCA",
        "localidad": "MONTE CARMELO",
        "solicitante": "IVÁN DÍAZ ROSALES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "DISI740302MHGZNN03",
        "camino": "NUEVO HORIZONTE",
        "municipio": "OMITLÁN DE JUÁREZ",
        "localidad": "VENTA DE GUADALUPE",
        "solicitante": "INÉS DIAZ SÁNCHEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MAOC830707MHGTLL05",
        "camino": "CRUZ DE MUJER-CERRO GORDO",
        "municipio": "OMITLÁN DE JUÁREZ",
        "localidad": "CRUZ DE MUJER",
        "solicitante": "CLAUDIA MATA OLVERA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "DILF830707HHGZCR05",
        "camino": "PRINCIPAL LOS TAPANCOS",
        "municipio": "OMITLÁN DE JUÁREZ",
        "localidad": "LOS TAPANCOS",
        "solicitante": "FERMÍN DIAZ LICONA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MIMA630202HHGRNL07",
        "camino": "SAN BUENAVENTURA-SAN MATEO BUENAVISTA",
        "municipio": "TEPEJI DEL RIO",
        "localidad": "SAN MATEO BUENAVISTA",
        "solicitante": "ALFONSO MIRANDA MÓNICO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "JIAD9400807HMCMLG04",
        "camino": "ACCESO PRINCIPAL CANOAS-CORRALES",
        "municipio": "TEPEJI DEL RIO",
        "localidad": "CANOAS",
        "solicitante": "DIEGO ARMANDO JIMÉNEZ ALCÁNTARA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BAAI840505MHGSLM02",
        "camino": "SAN MATEO BUENAVISTA-SAN IGNACIO NOPALA",
        "municipio": "TEPEJI DEL RIO",
        "localidad": "SAN IGNACIO NOPALA",
        "solicitante": "IMELDA BASTIDA ALANIZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "IAAY950517MHGSGR08",
        "camino": "VELAZCO-CUCHILAPAN",
        "municipio": "OMITLÁN DE JUÁREZ",
        "localidad": "RINCÓN CHICO",
        "solicitante": "YARELI ISLAS AGUILAR",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "FEVO801120HMCRGC08",
        "camino": "ACCESO AL ARQUITO",
        "municipio": "HUASCA DE OCAMPO",
        "localidad": "LOS REYES TEPEZALÁ",
        "solicitante": "OCTAVIO FERNÁNDEZ VEGA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PELE780804MDFRND04",
        "camino": "CALLE 5 DE MAYO",
        "municipio": "SANTIAGO DE ANAYA",
        "localidad": "CERRITOS",
        "solicitante": "EDITH PÉREZ LEÓN",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "JAJT690211MHGNVR04",
        "camino": "CALLE PACHUCA-MONTEREY",
        "municipio": "SANTIAGO DE ANAYA",
        "localidad": "CERRITOS",
        "solicitante": "TERESA JAÉN JAVIER",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AEMA540917HHGNLL03",
        "camino": "MOCTEZUMA",
        "municipio": "SAN AGUSTÍN TLAXIACA",
        "localidad": "LA NOPALERA",
        "solicitante": "ALBERTO ÁNGELES MELO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HISP670628HHGDLB16",
        "camino": "ACCESO EJIDO SAN MARTIN",
        "municipio": "ATOTONILCO EL GRANDE",
        "localidad": "CUMBRE DE SANTA CATARINA",
        "solicitante": "PABLO HIDALGO SOLARES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MAGR720326HHGNLM01",
        "camino": "CANAL DEL NORTE",
        "municipio": "MIXQUIAHUALA DE JUÁREZ",
        "localidad": "VERACRUZ",
        "solicitante": "RAMÓN MANZO GÁLVEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "VEBJ771014HHGGCN00",
        "camino": "JIHUICO-JILIAPA",
        "municipio": "METZTITLÁN",
        "localidad": "JILIAPA",
        "solicitante": "JUAN CARLOS VEGA BACA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BARA550927HHGTSN07",
        "camino": "JALAPA-OHUESCO",
        "municipio": "ZACUALTIPÁN DE ÁNGELES",
        "localidad": "JALAPA",
        "solicitante": "ANTONIO BAUTISTA RÍOS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BAHF700922HHGTRL04",
        "camino": "HUITZIZILINGO-TEXCATLA",
        "municipio": "SAN FELIPE ORIZATLÁN",
        "localidad": "HUITZIZILINGO",
        "solicitante": "FELIPE BAUTISTA HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MOBF950711HDFNRR03",
        "camino": "ACCESO PUNTA DE HUALULA",
        "municipio": "ELOXOCHITLÁN",
        "localidad": "HUALULA",
        "solicitante": "FERNANDO MONROY BARRERA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "ROMN741223MHGDRL02",
        "camino": "CANAL EL TUMBA",
        "municipio": "FRANCISCO I. MADERO",
        "localidad": "FRANCISCO VILLA",
        "solicitante": "NELLYBETH RODRÍGUEZ MARTÍNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "OIMV730707HHGLTC03",
        "camino": "ACCESO EL TIZAL",
        "municipio": "HUASCA DE OCAMPO",
        "localidad": "EL TIZAL",
        "solicitante": "VICENTE OLIVO MATA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AUGO851001HHGGDC05",
        "camino": "CRUCERO EL BUENA-SAN MIGUEL TIGUI",
        "municipio": "CARDONAL",
        "localidad": "EL BUENA",
        "solicitante": "OCTAVIO AGUA GODÍNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "VIRF840523HHGLSR03",
        "camino": "EL DORADO",
        "municipio": "CHAPANTONGO",
        "localidad": "CHAPULACO",
        "solicitante": "FREDY VILLEDA RESÉNDIZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "VENE850909MHGNVV01",
        "camino": "LAS TROQUES-EL ASTILLERO",
        "municipio": "HUICHAPAN",
        "localidad": "EL GAVILLERO DE MINTHO",
        "solicitante": "EVELIA VENTURA NAVA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "EIVM921016HHGSRR00",
        "camino": "EL PROGRESO",
        "municipio": "TENANGO DE DORIA",
        "localidad": "EL PROGRESO",
        "solicitante": "MARGARITO ESPÍNDOLA VARGAS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GACD781229HHGRRV09",
        "camino": "FRANCISCO ZARCO, NICOLÁS BRAVO, MIGUEL HIDALGO, XITHEJE-EL RETIRO",
        "municipio": "TEPETITLÁN",
        "localidad": "EL RETIRO",
        "solicitante": "DAVID GARCÍA CORONA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GUSA971014HHGZNR09",
        "camino": "COBAEH SAN MATEO-SAN PEDRO PAHUATLAN",
        "municipio": "ACAXOCHITLÁN",
        "localidad": "SAN MATEO",
        "solicitante": "JOSÉ ARMANDO GUZMÁN SANTOS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RASD920709MHGMNL01",
        "camino": "CHICONCUAC-TEPOYANGO",
        "municipio": "TLANALAPA",
        "localidad": "CHICONCUAC",
        "solicitante": "DULCE KARINA RAMÓN SAN AGUSTÍN",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BEMA941022HHGCND02",
        "camino": "CALLE NARCIZO MENDOZA",
        "municipio": "AJACUBA",
        "localidad": "AJACUBA",
        "solicitante": "ADRIÁN BECERRA MONROY",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CAMR050831HHGNRMA5",
        "camino": "CALLE LÁZARO CÁRDENAS",
        "municipio": "AJACUBA",
        "localidad": "EMILIANO ZAPATA",
        "solicitante": "JOSÉ RAMÓN CANO MORENO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MOVS711009MVZRRF05",
        "camino": "CALLE CANTERA",
        "municipio": "EL ARENAL",
        "localidad": "SAN JOSÉ TEPENENE",
        "solicitante": "SOFIA MORALES VARGAS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GUCY031103MHGZNSA9",
        "camino": "ACCESO AL BARRIO LA PRESA",
        "municipio": "ACAXOCHITLÁN",
        "localidad": "ZACACUAUTLA",
        "solicitante": "YESENIA GUZMÁN CANALES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "COHC671122HHGRRRC02",
        "camino": "BARRIO TEOMPANCALANI",
        "municipio": "XOCHICOATLAN",
        "localidad": "TEXCACO",
        "solicitante": "CECILIO CORTES HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "EIMB970410HHGSRR02",
        "camino": "PRINCIPAL DEL BOÑHU",
        "municipio": "ZIMAPÁN",
        "localidad": "BOÑHU",
        "solicitante": "BRUNO ESPINO MARTÍNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AAQI701119HHGLJS07",
        "camino": "CALLEJÓN VICENTE GUERRERO",
        "municipio": "TEZONTEPEC DE ALDAMA",
        "localidad": "PANUAYA",
        "solicitante": "J. ISABEL ÁLVAREZ QUIJANO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "LOBF021021HHGPTRA4",
        "camino": "CALLE BUENOS AIRES",
        "municipio": "AJACUBA",
        "localidad": "TULANCALCO",
        "solicitante": "FREDY MISAEL LÓPEZ BAUTISTA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BARA980316MHGRCL05",
        "camino": "CALLE JALISCO-QUETZALCÓATL-DEL MAESTRO",
        "municipio": "AJACUBA",
        "localidad": "IGNACIO ZARAGOZA",
        "solicitante": "ALEXANDRA LIZBETH BÁRCENAS ROCHA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SAAR850207MHGNLY01",
        "camino": "PUENTE CAMARONES-LAS JUNTAS",
        "municipio": "SAN BARTOLO TUTOTEPEC",
        "localidad": "LAS JUNTAS",
        "solicitante": "REYNA SANTOS ALMARAZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CORP590819HVZNSD09",
        "camino": "EL VELADERO",
        "municipio": "ACATLÁN",
        "localidad": "EL VELADERO",
        "solicitante": "PEDRO CONTRERAS ROSADO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "BALJ870428HDFLCN03",
        "camino": "JARILLAL-LAS PUENTES",
        "municipio": "CUAUTEPEC DE HINOJOSA",
        "localidad": "EL JARILLAL",
        "solicitante": "JUAN PABLO BALDERAS LICONA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SAMG800128MHGNNR09",
        "camino": "SAN MIGUEL ARCÁNGEL",
        "municipio": "SAN AGUSTÍN TLAXIACA",
        "localidad": "SANTA MARÍA TORNACUXTLA",
        "solicitante": "GRISELDA SÁNCHEZ MENDOZA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "VIAJ710409HHGVCL05",
        "camino": "ACCESO PANTADHO",
        "municipio": "METZTITLÁN",
        "localidad": "PANTADHO",
        "solicitante": "JULIÁN VIVEROS ACOSTA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AAGZ961126MHGLRR01",
        "camino": "PALMITAS",
        "municipio": "PISAFLORES",
        "localidad": "PALMITAS",
        "solicitante": "ZAIRA ROCIÓ ÁLVAREZ GARCÍA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GUMR890213HSPRRB05",
        "camino": "MIAHUATLA-LA MESA",
        "municipio": "CHAPULHUACAN",
        "localidad": "MIAHUATLA",
        "solicitante": "RUBICEL GUERRERO MARTÍNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SAF820922MHGNNL03",
        "camino": "LA RIVERA",
        "municipio": "METZTITLÁN",
        "localidad": "LA RIVERA",
        "solicitante": "MARÍA FÉLIX SÁNCHEZ SÁNCHEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AIMS830610HHGRYM03",
        "camino": "COATITLAMIXTLA-XOCHICOATLAN",
        "municipio": "XOCHICOATLAN",
        "localidad": "COATITLAMIXTLA",
        "solicitante": "SIMÓN ARIAS MAYA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MOTA860420HHGNLB02",
        "camino": "SAN LORENZO ACHIOTEPEC-EL BORBOLLÓN",
        "municipio": "HUEHUETLA",
        "localidad": "SAN LORENZO ACHIOTEPEC",
        "solicitante": "ABEL MAIM MONTES TOLENTINO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "COBM820717HHGBTR05",
        "camino": "AHUAMOLOS-PEZMATLAN",
        "municipio": "CALNALI",
        "localidad": "AHUAMOLOS",
        "solicitante": "MARCELINO COBOS BAUTISTA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HELA601103HHGRRR09",
        "camino": "AV. DEL POZO",
        "municipio": "SANTIAGO TULANTEPEC",
        "localidad": "LOS ROMEROS",
        "solicitante": "ARMANDO HERNÁNDEZ LARIOS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "ROMF590606HHGDRL06",
        "camino": "AV. UNIÓN",
        "municipio": "TEPEJI DEL RIO",
        "localidad": "CANTERA DE VILLAGRÁN",
        "solicitante": "FILIBERTO RODRÍGUEZ MIRANDA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MAMC690429HHGRRR09",
        "camino": "4 DE MAYO",
        "municipio": "TASQUILLO",
        "localidad": "PORTEZUELO",
        "solicitante": "J. CRUZ MARTIN MARTÍNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MOHA930811HHGNRR11",
        "camino": "SAN MARTIN",
        "municipio": "ACAXOCHITLÁN",
        "localidad": "SAN MARTIN",
        "solicitante": "ARMANDO MONROY HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CUHG950827HHGRRS03",
        "camino": "ACCESO TETLALPAN",
        "municipio": "CHAPULHUACAN",
        "localidad": "TETLALPAN",
        "solicitante": "GUSTAVO CRUZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEHH830316HHGRRR12",
        "camino": "TLAZINTLA-EL PUERTO",
        "municipio": "SAN FELIPE ORIZATLÁN",
        "localidad": "AHUATITLA",
        "solicitante": "HERIBERTO HERNÁNDEZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "VIAN850910MHGLRC03",
        "camino": "CALLE S/N",
        "municipio": "ZIMAPÁN",
        "localidad": "XINDHO PRIMERO",
        "solicitante": "NICOLÁSA VILLEDA ARTEAGA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AEOG940710MDFCCR08",
        "camino": "ENTRADA PRINCIPAL XITHA PRIMERO",
        "municipio": "ZIMAPÁN",
        "localidad": "XITHA PRIMERO",
        "solicitante": "GRACIELA ACEVEDO OCAMPO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MUMH830607HHGXRC01",
        "camino": "LLANO SEGUNDO",
        "municipio": "ZIMAPÁN",
        "localidad": "LLANO SEGUNDO",
        "solicitante": "HÉCTOR JESÚS MUÑOZ MARTÍNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CIMA920723HHGRRR03",
        "camino": "ENTRONQUE COM. LA ESCONDIDA",
        "municipio": "CHAPULHUACAN",
        "localidad": "LA ESCONDIDA",
        "solicitante": "ARISTEO CIRILO MARTÍNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MOTE010121MHGRRVA7",
        "camino": "LA FLORIDA-CUAUHTÉMOC",
        "municipio": "TASQUILLO",
        "localidad": "LA FLORIDA",
        "solicitante": "EVA MORALES TREJO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "LAEZ630826HHGBRF00",
        "camino": "ACCESO AL PARAJE \"LA MOJONERA\"",
        "municipio": "TASQUILLO",
        "localidad": "RINCONADA",
        "solicitante": "ZEFERINO LABRA ERREGUIN",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RAGM800904MHGMRR06",
        "camino": "BARRIO LOS RAMÍREZ",
        "municipio": "TECOZAUTLA",
        "localidad": "BOTHE TECOZAUTLA",
        "solicitante": "MARIBEL RAMÍREZ GIRÓN",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "EIVM921016HHGSRR00",
        "camino": "EL PROGRESO",
        "municipio": "TENANGO DE DORIA",
        "localidad": "EL PROGRESO",
        "solicitante": "MARGARITO ESPÍNDOLA VARGAS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEHJ650406HHGRRS02",
        "camino": "TATACUATITLA",
        "municipio": "SAN FELIPE ORIZATLÁN",
        "localidad": "TATACUATITLA",
        "solicitante": "JOSÉ HERNÁNDEZ HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "ROPE540921MHGSRF02",
        "camino": "ENT. XUCHITLAN-ENT. LA FLORIDA",
        "municipio": "LOLOTLA",
        "localidad": "QUIMIXTLA",
        "solicitante": "IFIGENIA DEL ROSAL PÉREZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MUOA730301HHGXRL02",
        "camino": "MESA DEL ÁNGEL",
        "municipio": "ZIMAPÁN",
        "localidad": "AGUAS BLANCAS",
        "solicitante": "ALBINO MUÑOZ ORTIZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CATW590901HHGHRN07",
        "camino": "MZA- CENTRO-MZA. EL NIETO",
        "municipio": "ZIMAPÁN",
        "localidad": "AGUAS BLANCAS",
        "solicitante": "WENCESLAO CHÁVEZ TREJO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GUAR791005HHGRRY05",
        "camino": "A UN LADO DEL CAMPO DE FUTBOL",
        "municipio": "OMITLÁN DE JUÁREZ",
        "localidad": "MANUEL TENIENTE",
        "solicitante": "RAYMUNDO GUERRERO ARELLANO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "SAXA770807HHGNXL09",
        "camino": "CAMINO REAL-PUERTO DE LA MUSICA-MACANGUI",
        "municipio": "LA MISIÓN",
        "localidad": "MACANGUI",
        "solicitante": "ALBERTO SÁNCHEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RAPA900226MHGMRL02",
        "camino": "ACCESO LOS ROMEROS",
        "municipio": "SANTIAGO TULANTEPEC",
        "localidad": "LOS ROMEROS",
        "solicitante": "ALEJANDRA RAMÍREZ SÁNCHEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RORA690626MHGMBN08",
        "camino": "LA AMECA-CHALAHUITE",
        "municipio": "PISAFLORES",
        "localidad": "LA AMECA",
        "solicitante": "ANTELMA ROMERO RUBIO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CAFC850202MHGDLN08",
        "camino": "AV. LA JOYA",
        "municipio": "TEPETITLÁN",
        "localidad": "LA JOYA",
        "solicitante": "CÁNDIDA CADENA FLORES",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MOZA801025HHGNML07",
        "camino": "CALLE CERRADA EMILIANO ZAPATA",
        "municipio": "FRANCISCO I. MADERO",
        "localidad": "EL ROSARIO",
        "solicitante": "ALBERTO MONROY ZAMORA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CAPL800621MHGSDS01",
        "camino": "CALLE LLORÓN",
        "municipio": "CUAUTEPEC DE HINOJOSA",
        "localidad": "LA CAÑADA",
        "solicitante": "MARÍA LUISA CASTILLO PADILLA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GATH791216MHGRPD00",
        "camino": "CALLE IGNACIO COMONFORT-CAMINO RUMBO AL SALTO",
        "municipio": "TEPEJI DEL RIO",
        "localidad": "TIANGUISTENGO",
        "solicitante": "HEIDY IMELDA GARCÍA TAPIA",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "HEXE650430HSPRXV02",
        "camino": "LAS MORAS-EL ARROYO SECO",
        "municipio": "PISAFLORES",
        "localidad": "LAS MORAS",
        "solicitante": "EVARISTO HERNÁNDEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "PERG911202HHGRMN07",
        "camino": "CALLES PRINCIPALES, LOC. LOS ARCOS",
        "municipio": "METZTITLÁN",
        "localidad": "LOS ARCOS",
        "solicitante": "GENARO PÉREZ ROMERO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "OETA910102HHGRLL06",
        "camino": "LOS PLANES DE SANTIAGO",
        "municipio": "TENANGO DE DORIA",
        "localidad": "LOS PLANES DE SANTIAGO",
        "solicitante": "ALEJANDRO ORTEGA TOLENTINO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "AASF810129HHGNNR02",
        "camino": "MAZHAPA-SANTA MARÍA",
        "municipio": "HUAZALINGO",
        "localidad": "SANTA MARÍA",
        "solicitante": "FRANCISCO ANDRADE SANTOS",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "RANR830815HHGMRB08",
        "camino": "OHTLI IPAN ALTEPETL",
        "municipio": "YAHUALICA",
        "localidad": "PEPEYOCATITLA",
        "solicitante": "ROBERTO RAMÍREZ NARANJO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "MEMG910707HHGNLS08",
        "camino": "PALMA ANTIGUA-EL VITE",
        "municipio": "HUASCA DE OCAMPO",
        "localidad": "PALMA ANTIGUA",
        "solicitante": "GUSTAVO MÉNDEZ MELO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "CORM781102HHGYJG08",
        "camino": "BARRIO SAN MIGUEL-BARRIO LAS LOMAS",
        "municipio": "TECOZAUTLA",
        "localidad": "PAÑHE",
        "solicitante": "MIGUEL ÁNGEL COYOTE ROJO",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    },
    {
        "curp": "GUMD670512HHGZRM01",
        "camino": "TETZHU-CUAUHTÉMOC-LA FLORIDA-SAN ANTONIO CALTIMACAN",
        "municipio": "TASQUILLO",
        "localidad": "TETZHU",
        "solicitante": "DAMIÁN GUZMÁN MARTÍNEZ",
        "estatus": "EN CAPTURA Y REVISIÓN DE DOCUMENTACIÓN"
    }
]